import { useState,useEffect, useRef } from "react";
import { InvitedNewParticipant,InvitedParticipant, ProjectInfoInterface } from "../../model/IprojectInfo";
import { Avatar, Button, Card, Col, DatePicker, Flex, Form, Input, List, Modal, Radio, Row, Select, Table, Typography } from "antd";
import LoadingOverlay from 'react-loading-overlay-ts';
import moment from "moment";
import { FacilityInterface, ResearcherInterface } from "../../model/IResearcher";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Editor } from "ckeditor5";
import CkEditor from "../../ckeditor/ckEditor";
import { FlieListInterface } from "../../model/IFileList";
import {
    UploadOutlined,
    CheckOutlined,
    CloseOutlined
  } from '@ant-design/icons';
import { CommentInterface, CommitteeList } from "../../model/CommitteeList";
import dayjs from "dayjs";
import { TextDecoderStream } from "stream/web";
import { jsPDF } from "jspdf";
import puppeteer from 'puppeteer';
import { motion, AnimatePresence } from 'framer-motion';

interface Issue {
    Topic: string;
    Reccommendation: string;
  }

export function PresProjectInfo(){
    const [form] = Form.useForm();
    const [Editform] = Form.useForm();
    const navigate = useNavigate();
    const [isActive,setisActive]= useState(false);

    const [AllData,setAlldata] = useState<ProjectInfoInterface>();
    const [HisAllData,setHisAllData] = useState<ProjectInfoInterface>();

    const [HeadResData,setHeadResdata] = useState<ResearcherInterface>();
    const [ExHeadResData,setExHeadResdata] = useState<ResearcherInterface>();
    const [researcher_position, setresearcher_position] = useState('');
    const [JoinedData,setJoinedData] = useState<ResearcherInterface[]>([]);
    const [ExJoinedData,setExJoinedData] = useState<ResearcherInterface[]>([]);
    const isDifferent =
        JoinedData.length !== ExJoinedData.length ||
        JoinedData.some((item, index) =>
            JSON.stringify(item) !== JSON.stringify(ExJoinedData[index])
        );
    const [facData,setFacData] = useState<FacilityInterface>();

    const [ShowFile,setShowFile] = useState(false);
    const [ShowMultipleFiles,setShowMultipleFiles] = useState(false);
    const [ShowImage,setShowImage] = useState(false);
    const [SubFileList,setSubFileList] = useState<FlieListInterface[]>([])
    const [submit,setSubmit] = useState(false);
    const [previewUrl, setPreviewUrl] = useState<string | null>(null);
    const [FileType,setFileType] = useState<string | null>(null);
    const [Topic,setTopic] = useState('')

    const [limit,setLimit] = useState(0);
    const ReviewType = Form.useWatch('reviewType', form);
    const ReviewDeadline = Form.useWatch('ReviewDeadline', form);
    const Stats = Form.useWatch('status', Editform);
    const isValidReviewDeadline = moment(ReviewDeadline).isValid();

    const [ConfirmationMod,setConfirmationMod]= useState(false);
    const [PullBackConfirmation,setPullBackConfirmation]= useState(false);

    const [Part11Status,setPart11Status]= useState(true);
    const [Part12Status,setPart12Status]= useState(true);
    const [Part13Status,setPart13Status]= useState(true);
    const [Part14Status,setPart14Status]= useState(true);
    const [Part15Status,setPart15Status]= useState(true);
    const [Part2Status,setPart2Status]= useState(true);
    const [Part3Status,setPart3Status]= useState(true);
    const [Part3OutlineStatus,setPart3OutlineStatus]= useState(true);
    const [Part3CourseStatus,setPart3CourseStatus]= useState(true);
    const [Part3RecieptStatus,setPart3RecieptStatus]= useState(true);

    const [selectedTypes, setSelectedTypes] = useState<string[]>([]);


    const participants = [
      {
        order_id: 1,
        researcher_THname: HeadResData?.researcher_THname || 'error',
        join_per: HeadResData?.join_per || 0,
      },
      ...(JoinedData.length>0
          ? JoinedData.map((r, idx) => ({
              order_id: idx + 2, // head is order 1
              researcher_THname: r.researcher_THname,
              join_per: r.join_per || 0,
            }))
          : []),
    ];

    const [Committees,setCommittees] = useState<CommitteeList[]>([])
    const [SelectedCommittee,setSelectedCommittee] = useState<CommitteeList>();
    const [SelectedCommittees,setSelectedCommittees] = useState<CommitteeList[]>([]);
    const [Comment,setComment] = useState<CommentInterface[]>([]);
    const [EXComment,setEXComment] = useState<CommentInterface[]>([]);
    const [showEXComment,setshowEXComment] = useState<CommentInterface[]>([]);
    const [consideratIssuesAndArguement,setConsideratIssuesAndArguement] = useState([]);

    const [invitedParticipant, setInvitedParticipant] = useState<InvitedParticipant>();
    const [NewinvitedParticipant, setNewInvitedParticipant] = useState<InvitedNewParticipant>({
        normal: {
            count: null,
            note:'',
            age:'',
            age_year: null,
            age_month: null,
            gender: [],
            },
        kids: {
        count: null,
        note:'',
        age:'',
        age_year: null,
        age_month: null,
        gender: [],
        },
        vulnerable: {
        count: null,
        note:'',
        age:'',
        age_year: null,
        age_month: null,
        gender: [],
        },
        });
    const [invitedParticipantHistory, setInvitedParticipantHistory] = useState<InvitedParticipant>({
        healthy: {
          count: null,
          note:'',
          age:'',
          age_year: null,
          age_month: null,
          gender: [],
        },
        patient: {
          count: null,
          note:'',
          age:'',
          age_year: null,
          age_month: null,
          gender: [],
        },
        other: {
        othertype:'',
        count: null,
          note:'',
          age:'',
          age_year: null,
          age_month: null,
          gender: [],
        },
      });
      const [NewinvitedParticipantHistory, setNewInvitedParticipantHistory] = useState<InvitedNewParticipant>({
        normal: {
            count: null,
            note:'',
            age:'',
            age_year: null,
            age_month: null,
            gender: [],
            },
        kids: {
        count: null,
        note:'',
        age:'',
        age_year: null,
        age_month: null,
        gender: [],
        },
        vulnerable: {
        count: null,
        note:'',
        age:'',
        age_year: null,
        age_month: null,
        gender: [],
        },
        });

    const [AllFileList,setAllFileList] = useState<FlieListInterface[]>([])
      const [FileAttachment, setFileAttachment] = useState([
        {   
            id:1,
            AttachmentType:'เค้าโครงวิจัย 3 บท',
            Status:'ยังไม่แนบ'
        },{
            id:2,
            AttachmentType:'เครื่องมือหรือแบบสอบถาม (ถ้ามี)',
            Status:'ยังไม่แนบ'
        },
        {
            id:3,
            AttachmentType:'หนังสือรับรองการประเมินคุณภาพเครื่องมือวิจัย(ถ้ามี)',
            Status:'ยังไม่แนบ'
        },
        {
            id:4,
            AttachmentType:'เอกสารแสดงความยินยอมเข้าร่วมโครงการวิจัยสำหรับอาสาสมัครทั่วไป (ถ้าเกี่ยวข้อง)',
            Status:'ยังไม่แนบ'
        },
        {
            id:5,
            AttachmentType:'เอกสารแสดงความยินยอมเข้าร่วมโครงการวิจัยสำหรับอาสาสมัครเด็ก 7-18 ปี (ถ้าเกี่ยวข้อง)',
            Status:'ยังไม่แนบ'
        },
        {
            id:6,
            AttachmentType:'เอกสารแสดงความยินยอมสำหรับอาสาสมัครกลุ่มเปราะบาง (ถ้าเกี่ยวข้อง)',
            Status:'ยังไม่แนบ'
        },
        {
            id:7,
            AttachmentType:'เอกสารรับรองการสอบผ่านโครงร่างวิทยานิพนธ์ ภาคนิพนธ์ หรือการศึกษาค้นคว้าอิสระ',
            Status:'ยังไม่แนบ'
        },
        {
            id:8,
            AttachmentType:'เอกสารสัญญาการให้ทุนวิจัย',
            Status:'ยังไม่แนบ'
        },
        {
            id:9,
            AttachmentType:'หลักฐานการผ่านการอบรมจริยธรรมการวิจัยในมนุษย์',
            Status:'ยังไม่แนบ'
        },
        {
            id:10,
            AttachmentType:'หลักฐานการชำระเงินค่าธรรมเนียมในการพิจารณาจริยธรรมการวิจัยในมนุษย์',
            Status:'ยังไม่แนบ'
        },
        {
            id:11,
            AttachmentType:'หลักฐานการรับรองคำพิจารณาจริยธรรมจากที่ปรึกษา (สำหรับนักศึกษา)',
            Status:'ยังไม่แนบ'
          },
        ]);

    const ParticipantAmountRef = useRef<Editor | null>(null);
    const ParticipantProcedureRef = useRef<Editor | null>(null);
    const ParticipantGroupByRef = useRef<Editor | null>(null);

    const {ROCKEditors,CKEditors,getHTML} = CkEditor();

    function arraysHaveSameMembers(a: string[], b: string[]) {
        if (a.length !== b.length) return false;
        return a.every(val => b.includes(val));
        }

    async function getData(){
      console.log('check multiple run')
      await axios.get(`${process.env.REACT_APP_BASE}/getFullProjectInfo/${sessionStorage.getItem('Order_ID')}/${sessionStorage.getItem('head_ID')}`).then(response=>{
          if(response.status=200)
              {
                  console.log(response.data.data)
                  console.log(response.data.Joined)

                  const tmpdata = response.data.data
                  setAlldata(tmpdata)
                  

                  setresearcher_position(tmpdata.posname)

                  const head = response.data.Head

                  // Check part 1.1
                  if (
                    tmpdata.project_nameTH &&
                    tmpdata.project_nameEN &&
                    tmpdata.posname &&
                    head 
                    && tmpdata.project_type 
                    && tmpdata.IsQuestionair
                    && (tmpdata.ResearchPeriod_year || tmpdata.ResearchPeriod_month )
                    && tmpdata.ResearchStartingDate && tmpdata.ResearchEndingDate 
                    && (tmpdata.InfoGatheringPeriod_month || tmpdata.InfoGatheringPeriod_year )
                      && tmpdata.InfoGatheringStartingDate 
                      && tmpdata.InfoGatheringEndingDate && tmpdata.Projectfund
                  ) {
                    console.log('part1.1')
                    setPart11Status(false);
                  }

                  // Check part 1.2
                  if (
                    tmpdata.IsbloodDraw &&
                    tmpdata.IsInvasiveProcedure &&
                    tmpdata.RiskAndUncomfortableFactor &&
                    tmpdata.DefensiveMeasure &&
                    tmpdata.ExpenseCoverage &&
                    tmpdata.AcceptanceUnderstanding &&
                    tmpdata.IsCountryReligionRiskFactor
                  ) {
                    console.log('part1.2')
                    setPart12Status(false);
                  }

                  // Check part 1.3
                  if (tmpdata.IsMedicine && tmpdata.applicableFactor) {
                    console.log('part1.3')
                    setPart13Status(false)
                  }
                
                  // Check part 1.4 
                  if (
                    tmpdata.IsCommercialInterlectualProperty &&
                    tmpdata.ProgressReport &&
                    tmpdata.PlagiarismPer
                  ) {
                    console.log('part1.4')
                    setPart14Status(false)

                  }
                
                  // Check part 1.5
                  if (tmpdata.LangRecieve && tmpdata.Acceptance) {
                    console.log('part1.5')
                    setPart15Status(false)
                  }
                
                  // Check part 2
                  if (
                    tmpdata.relevantTopic &&
                    tmpdata.Objective &&
                    tmpdata.ParticipantCharacteristicAndCriterion &&
                    tmpdata.ParticipantAmount &&
                    tmpdata.ParticipantRecruit &&
                    tmpdata.ParticipantReason &&
                    tmpdata.ParticipantProcedure &&
                    tmpdata.ParticipantAcknowledgementMethod &&
                    tmpdata.MedicalRecordInfoAllowedByHead &&
                    tmpdata.MedicalRecordactionAllowedByHead &&
                    tmpdata.RiskAndPrevent &&
                    tmpdata.Benefit &&
                    tmpdata.Coverage
                  ) {
                    console.log('part2')
                    setPart2Status(false)
                  }
      
                //  
                  console.log(tmpdata.InvitedParticipant)
                  if(tmpdata.InvitedParticipant!=null&&tmpdata.InvitedParticipant!=''){
                      const data = JSON.parse(tmpdata.InvitedParticipant);
                      console.log(data)
                      const invitedTypes: string[] = [];
                      if (data?.patient) invitedTypes.push('ผู้ป่วย');
                      if (data?.healthy) invitedTypes.push('ผู้มีสุขภาพดี');
                      if (data?.other) invitedTypes.push('อื่น ๆ');

                      setInvitedParticipant(data)
                      setNewInvitedParticipant(data)
                  }

                  setHeadResdata({
                      ...head,
                      join_per:head.joinper
                  })
                  const Joined = response.data.Joined
                  setJoinedData(
                      Joined.map((item: { joinper: any; }) => ({
                        ...item,
                        join_per: item.joinper,
                      }))
                    )
                  console.log(tmpdata.project_nameTH)

                  if(tmpdata?.review_type){
                    if(tmpdata?.review_type=="การพิจารณาแบบยกเว้น (Exemption)"||
                        tmpdata?.review_type=="การพิจารณาแบบเร่งรัด (Expedited Review)"){
                        setLimit(2);
                    }else if(tmpdata?.review_type=='การพิจารณาแบบเต็มชุด (Full Board Review)'){
                        setLimit(3)
                    }}

                    if(tmpdata.project_status=='รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        tmpdata.project_status=='รอตรวจสอบผลการแก้ไขจากประธาน'||
                        tmpdata.project_status=='รอพิจารณาผลการแก้ไขจากกรรมการ'
                    ){
                        let considerationIssues = JSON.parse(tmpdata.consideration_issues)
                        let Arguement = JSON.parse(tmpdata.researcher_issues_arguement)
                        let considerationIssuesAndArguement = considerationIssues.map(
                            (issue: { topic: string; consideration_issues: string }, index: number) => ({
                              Topic: issue.topic,
                              Reccommendation: issue.consideration_issues,
                              Arguement: Arguement[index] || "" // safe fallback
                            }));
                            setConsideratIssuesAndArguement(considerationIssuesAndArguement)
                      }
                    
                  axios.get(`${process.env.REACT_APP_BASE}/getComment/${sessionStorage.getItem('Order_ID')}`).then(resp=>{
                    if(resp.status==200){
                        setComment(resp.data)
                        if(tmpdata.project_status=='ประธานฯแต่งตั้งกรรมการใหม่'){
                            setSelectedCommittees(resp.data) 
                        }
                    }
                  })
              }

      })
     
      await axios
      .get(`${process.env.REACT_APP_BASE}/getFileList/${sessionStorage.getItem('Order_ID')}`)
      .then((res) => {
        if (res.status === 200 && res.data) {
          const uploadedFiles = res.data; // Array of { Topic: string }
    
          const updatedList = FileAttachment.map((item) => {
            const isUploaded = uploadedFiles.some(
              (file: { Topic: string }) => file.Topic === item.AttachmentType
            );
            return {
              ...item,
              Status: isUploaded ? 'แนบแล้ว' : 'ยังไม่แนบ',
            };
          });
    
          setAllFileList(uploadedFiles);
          setFileAttachment(updatedList);

          const requiredTopics = [
            'เค้าโครงวิจัย 3 บท',
            'หลักฐานการผ่านการอบรมจริยธรรมการวิจัยในมนุษย์',
            'หลักฐานการชำระเงินค่าธรรมเนียมในการพิจารณาจริยธรรมการวิจัยในมนุษย์',
          ];
    
          const allRequiredUploaded = requiredTopics.every((requiredTopic) =>
            uploadedFiles.some((file: { Topic: string }) => file.Topic.trim() === requiredTopic)
          );

          if(uploadedFiles.filter((item:{ Topic: string })=>item.Topic.trim()=='เค้าโครงวิจัย 3 บท')){
            setPart3OutlineStatus(false)
        }
        if(uploadedFiles.filter((item:{ Topic: string })=>item.Topic.trim()=='หลักฐานการผ่านการอบรมจริยธรรมการวิจัยในมนุษย์')){
            setPart3CourseStatus(false)
        }
        if(uploadedFiles.filter((item:{ Topic: string })=>item.Topic.trim()=='เค้าโครงวิจัย 3 บท')){
            setPart3RecieptStatus(false)
        }
  
        if (allRequiredUploaded) {
            console.log('part3')
            setPart3Status(false)
        }
        }
      });
    }

    async function getProjectback(){
        await axios.get(`${process.env.REACT_APP_BASE}/GetProjectBack/${sessionStorage.getItem('Order_ID')}`)
        .then((res)=>{
            if(res.status){
                window.location.reload();
            }
        })
    }

    async function viewFile(Topic:any){
        setTopic(Topic)
        if (Topic === "เครื่องมือหรือแบบสอบถาม (ถ้ามี)"
        ||Topic === "เอกสารสัญญาการให้ทุนวิจัย"
          ) {
              setisActive(true);
              const filtered = AllFileList.filter(item => item.Topic.trim() === Topic);
              console.log(filtered);
              setSubFileList(filtered);
              setShowMultipleFiles(true);
              setisActive(false);
          }else if(Topic=='หลักฐานการผ่านการอบรมจริยธรรมการวิจัยในมนุษย์'){
          
          const filtered = AllFileList.filter(item => item.Topic.trim() === Topic);
          console.log(filtered[0].FileType)
          if(filtered[0].FileType=='image/jpeg'||filtered[0].FileType=='image/png'){
              setPreviewUrl(`${process.env.REACT_APP_BASE}/getImage/${filtered[0].FileID}`)
              setShowImage(true);
          }else{
              const data = {
                  topic:Topic
              }
  
              await axios.post(
                  `${process.env.REACT_APP_BASE}/GetFile/${sessionStorage.getItem('Order_ID')}`,
                  data,
                  { responseType: 'blob' }
                  ).then(response => {
                  if (response.status === 200) {
                      
                      const blob = response.data; // Axios already gives you a Blob
                      const blobUrl = URL.createObjectURL(blob);
                  
                      setPreviewUrl(blobUrl);    // For <iframe> src
                      setShowFile(true);         // Show modal/dialog/preview
                      setisActive(false);        // Stop loading spinner, etc.
                  }
                  }).catch(err => {
                  console.error("Error while fetching file:", err);
                  setisActive(false);
                  });
          }
          }else{
              setisActive(true)
              const data = {
                  topic:Topic
              }
              
              await axios.post(
                  `${process.env.REACT_APP_BASE}/GetFile/${sessionStorage.getItem('Order_ID')}`,
                  data,
                  { responseType: 'blob' }
              ).then(response => {
                  if (response.status === 200) {
                      
                  const blob = response.data; // Axios already gives you a Blob
                  const blobUrl = URL.createObjectURL(blob);
              
                  setPreviewUrl(blobUrl);    // For <iframe> src
                  setShowFile(true);         // Show modal/dialog/preview
                  setisActive(false);        // Stop loading spinner, etc.
                  }
              }).catch(err => {
                  console.error("Error while fetching file:", err);
                  setisActive(false);
              });
              
          }
    }

  async function ViewTool(id:any){
    const data = {
        topic:Topic,
    }
    await axios.post(
        `${process.env.REACT_APP_BASE}/GetFileForMultiplePDFAccept/${sessionStorage.getItem('Order_ID')}/${id}`,
        data,
        { responseType: 'blob' }
      ).then(response =>{
        if (response.status === 200) {
            setFileType(response.headers['content-type'])
            console.log('Content-Type:', response.headers['content-type']);

            const blob = response.data; 
            const blobUrl = URL.createObjectURL(blob);

            setPreviewUrl(blobUrl); 
        }
      }).catch(err => {
        console.error("Error while fetching file:", err);
        setisActive(false);
      });
   
    }


    const getList = async()=>{
      await axios.get(`${process.env.REACT_APP_BASE}/GetCommitteeList`).then((response)=>{
          if(response.status==200){
              setCommittees(response.data)
          }
      })
     }

    function addCommittee(){
        console.log(SelectedCommittees)
        console.log(SelectedCommittee)
        const tmp = SelectedCommittees
        if(SelectedCommittee)
            {
                tmp.push(SelectedCommittee)
                form.setFieldsValue({
                    committeeName: undefined 
                  });
                setSelectedCommittee(undefined)
            }
    }

    const DeleteCommittee = (id: number) => {
        // logic to remove the committee
        setSelectedCommittees(prev => prev.filter(item => item.CommitteeID !== id));
      };

    const SetData = () =>{
        const FormData = form.getFieldsValue();
        const data = {
            ReviewType:FormData.reviewType||AllData?.review_type,
            CommitteeList:SelectedCommittees,
            addBy:sessionStorage.getItem('user'),
            ReviewDeadline:FormData.ReviewDeadline,
            role:sessionStorage.getItem('role'),
            status:AllData?.project_status,
            EditNum:AllData?.EditNumber
        }


        axios.post(`${process.env.REACT_APP_BASE}/SendToCommittee/${sessionStorage.getItem('Order_ID')}`,data).then((response)=>{
            if(response.status==200){
                navigate('/VU_HREC/RequestListView')
            }
        })
    }

    const SentEditedData = async() =>{
        const FormData = Editform.getFieldsValue();
        const data = {
            status:FormData.status,
            addBy:sessionStorage.getItem('user'),
            ReviewDeadline:FormData.ReviewDeadline,
            EditNum:AllData?.EditNumber,
            role:sessionStorage.getItem('role')

        }
        await axios.post(`${process.env.REACT_APP_BASE}/SendToCommittee/${sessionStorage.getItem('Order_ID')}`,data).then(response=>{
            if(response.status==200){
                navigate('/VU_HREC/RequestListView')
            }
        })
    }

    async function getHist(){
        await axios.get(`${process.env.REACT_APP_BASE}/getFullProjectInfoPasted/${sessionStorage.getItem('Order_ID')}/${sessionStorage.getItem('head_ID')}`).then(response=>{
            if(response.status==200){
                console.log(response.data)
                const tmpdata = response.data.data
                
                const head = response.data.Head
                
                console.log(response.data.Joined)


                  if(tmpdata.InvitedParticipant!=null&&tmpdata.InvitedParticipant!=''){
                    const Histdata = JSON.parse(tmpdata.InvitedParticipant);
                    const invitedTypes: string[] = [];
                    if (Histdata?.patient) invitedTypes.push('ผู้ป่วย');
                    if (Histdata?.healthy) invitedTypes.push('ผู้มีสุขภาพดี');
                    if (Histdata?.other) invitedTypes.push('อื่น ๆ');

                    setSelectedTypes(invitedTypes)
                    setInvitedParticipantHistory(Histdata)
                    setNewInvitedParticipantHistory(Histdata)
                }

                if(AllData?.project_status=='แก้ไขข้อมูลตามผลพิจารณา'){
                    setAlldata(tmpdata)
                    if(tmpdata.InvitedParticipant!=null&&tmpdata.InvitedParticipant!=''){
                        const Histdata = JSON.parse(tmpdata.InvitedParticipant);
                        const invitedTypes: string[] = [];
                        if (Histdata?.patient) invitedTypes.push('ผู้ป่วย');
                        if (Histdata?.healthy) invitedTypes.push('ผู้มีสุขภาพดี');
                        if (Histdata?.other) invitedTypes.push('อื่น ๆ');
    
                        setSelectedTypes(invitedTypes)
                        setInvitedParticipant(Histdata)
                    }
                    setHeadResdata({
                        ...head,
                        join_per:head.joinper
                    })
                    setJoinedData(
                        response.data.Joined.map((item: { joinper: any }) => ({
                          ...item,
                          join_per: item.joinper,
                        }))
                      );
                }else{
                    setHisAllData(tmpdata)
                    if(tmpdata.InvitedParticipant!=null&&tmpdata.InvitedParticipant!=''){
                        const Histdata = JSON.parse(tmpdata.InvitedParticipant);
                        const invitedTypes: string[] = [];
                        if (Histdata?.patient) invitedTypes.push('ผู้ป่วย');
                        if (Histdata?.healthy) invitedTypes.push('ผู้มีสุขภาพดี');
                        if (Histdata?.other) invitedTypes.push('อื่น ๆ');
    
                        setSelectedTypes(invitedTypes)
                        setInvitedParticipantHistory(Histdata)
                        setNewInvitedParticipantHistory(Histdata)
                    }
                    setExHeadResdata({
                        ...head,
                        join_per:head.joinper
                    })

                    setExJoinedData(
                        response.data.Joined.map((item: { joinper: any }) => ({
                          ...item,
                          join_per: item.joinper,
                        }))
                      );
    
                }



            }
        })
      }

      async function getCommentHistory(){
            await axios.get(`${process.env.REACT_APP_BASE}/getExReview/${sessionStorage.getItem('Order_ID')}`).then(response=>{
                if(response.status=200){
                    setEXComment(response.data)
                }
            })
        }
    useEffect(() => {
      getData();
      getList();
      if(
            AllData?.project_status=='รอตรวจสอบผลการแก้ไขจากประธาน'
            ||AllData?.project_status=='รอพิจารณาผลการแก้ไขจากกรรมการ'
            ||AllData?.project_status=='แก้ไขข้อมูลตามผลพิจารณา'
        ){
            getHist();
            getCommentHistory();
        }
        }, [AllData?.project_status]);

    return(<>
      <LoadingOverlay
            active={isActive}
            spinner
            text='กำลังโหลดข้อมูล'
        >
            <div id="part1-1"/>
            <h1>ข้อมูลโครงการ</h1>
            <hr/>
            {AllData?.project_status=='แก้ไข'&&
                <Card>
                    <p>หมายเหตุ : คำขอนี้ยังอยู่ในขั้นตอนการแก้ไข คุณสามารถดูและตรวจสอบส่วนที่ยังไม่กรอกของโครงการนี้ได้เท่านั้น</p>
                    {
                         (Part11Status
                            ||Part12Status
                            ||Part13Status
                            ||Part14Status
                            ||Part15Status
                            ||Part2Status
                            ||Part3Status
                          )&&<>
                            <Card>
                                <p>โครงการนี้ยังมีการกรอกไม่ครบถ้วน ผู้ยื่นคำขอยังขาดข้อมูลในส่วนต่อไปนี้</p>
                                {
                                (Part11Status
                                ||Part12Status
                                ||Part13Status
                                ||Part14Status
                                ||Part15Status
                                )&&<>
                                    <p style={{fontWeight:'bold',color:'red'}}>มว.จ. 001 คำขอรับรองการพิจารณาจริยธรรมการวิจัยในมนุษย์</p>
                                    <p style={{marginLeft:20,fontWeight:'bold',color:'red'}}>หัวข้อย่อยที่ขาด</p>
                                    {Part11Status&&<p style={{marginLeft:30,color:'red'}}>1. ข้อมูลเบื้องต้น</p>}
                                    {Part12Status&&<p style={{marginLeft:30,color:'red'}}>2. การพิจารณาจริยธรรม</p>}
                                    {Part13Status&&<p style={{marginLeft:30,color:'red'}}>3. ยา</p>}
                                    {Part14Status&&<p style={{marginLeft:30,color:'red'}}>4. ทรัพย์สินทางปัญญาและอื่น</p>}
                                    {Part15Status&&<p style={{marginLeft:30,color:'red'}}>5. คำรับรองจากผู้วิจัย</p>}

                                </>
                            }
                                {
                                    (Part2Status)&&
                                    <>
                                        <p style={{fontWeight:'bold',color:'red'}}>มว.จ. 002 แบบเอกสารชี้แจงอาสาสมัคร เพื่อประกอบการพิจารณาจริยธรรมการวิจัยในมนุษย์</p>
                                    </>
                                }
                                {
                                    (Part3Status)&&
                                    <>
                                        <p style={{fontWeight:'bold',color:'red'}}>มว.จ. 003 แนบเอกสารหลักฐานเพิ่มเติม</p>
                                    </>
                                }
                                        </Card>
                                    </>
                        }
                </Card>}
                <hr/>
            <h2>มว.จ.001 คำขอรับรองการพิจารณาจริยธรรมการวิจัยในมนุษย์ </h2>
            <Card>
            <h2>1.1 ข้อมูลเบื้องต้น</h2>
            <hr/>
            <Row>
                <Col span={12}>
                <p>
                <span style={{ fontWeight: 'bold' }}>ชื่อโครงการวิจัย (ภาษาไทย) :</span>{' '}
                <span
                    style={{
                    color:
                        (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                        ) &&
                        AllData?.project_nameTH !== HisAllData?.project_nameTH
                        ? '#FFCE1B'
                        : 'black',
                    }}
                >
                    {AllData?.project_nameTH || 'ยังไม่กรอกข้อมูล'}
                </span>
                </p>
                    
                </Col>
                <Col span={12}>
                    <p><span style={{ fontWeight: 'bold' }}>ชื่อโครงการวิจัย (ภาษาอังกฤษ) :</span>{' '}<span
                    style={{
                    color:
                        (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                        ) &&
                        AllData?.project_nameEN !== HisAllData?.project_nameEN
                        ? '#FFCE1B'
                        : 'black',
                    }}
                    >{AllData?.project_nameEN||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</span></p>
                </Col>
            </Row>
            <p> <span style={{ fontWeight: 'bold' }}>ชื่อหัวหน้าโครงการวิจัย :</span>{' '}
            <span
                style={{
                color:
                    AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา' && 
                    AllData?.researcher_THname !== HisAllData?.researcher_THname
                    ? '#FFCE1B'
                    : 'black',  
                }}
            >{HeadResData?.researcher_THname||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</span>({' '}
                <span
                    style={{
                    color:
                        AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา' && 
                        AllData?.researcher_ENname !== HisAllData?.researcher_ENname
                        ? '#FFCE1B'
                        : 'black',  
                    }}
            >{HeadResData?.researcher_ENname||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</span>)</p>
            <p> <span style={{ fontWeight: 'bold' }}>ตำแหน่งหัวหน้าโครงการวิจัย: </span><span style={{
                color:
                    AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา' && 
                    AllData?.researcher_THname !== HisAllData?.researcher_THname
                    ? '#FFCE1B'
                    : 'black',  
                }}>{HeadResData?.posname||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</span></p>
            <p> <span style={{ fontWeight: 'bold' }}>สังกัดหัวหน้าโครงการวิจัย : </span><span style={{
                color:
                    AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา' && 
                    AllData?.researcher_THname !== HisAllData?.researcher_THname
                    ? '#FFCE1B'
                    : 'black',  
                }}>{HeadResData?.researcher_facility||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</span></p>
            <p> <span style={{ fontWeight: 'bold' }}>เบอร์โทรศัพท์ติดต่อหัวหน้าโครงการวิจัย :</span> <span style={{
                color:
                    AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา' && 
                    AllData?.researcher_THname !== HisAllData?.researcher_THname
                    ? '#FFCE1B'
                    : 'black',  
                }}>{HeadResData?.researcher_phone||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</span> </p>
            <p> <span style={{ fontWeight: 'bold' }}>Email หัวหน้าโครงการวิจัย :</span>  <span style={{
                color:
                    AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา' && 
                    AllData?.researcher_THname !== HisAllData?.researcher_THname
                    ? '#FFCE1B'
                    : 'black',  
                }}>{HeadResData?.researcher_email||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</span></p>
            <br/>
            {isDifferent&&
            (   
                AllData?.project_status!='แก้ไข'&&
                AllData?.project_status!='ได้รับหนังสือรับรองจากอธิการบดี'&&
                AllData?.project_status!='รอตรวจสอบจากเจ้าหน้าที่'&&
                AllData?.project_status!='รอการตรวจสอบผลพิจารณา'&&
                AllData?.project_status!='รอตรวจสอบจากประธานจริยธรรม'&&
                AllData?.project_status!='รอการพิจารณาจากกรรมการ'&&
                AllData?.project_status!='ไม่อนุมัติ'&&
                AllData?.project_status!='ประธานฯแต่งตั้งกรรมการใหม่'
            )&&<>
                <Card>
                    ข้อมูลบางส่วนของผู้ร่วมวิจัยมีการเปลี่ยนแปลง
                </Card>
            <br/>
            </>}
            {JoinedData.map((item, idx) => (
                <>
                <Card key={idx}>
                    <p><span style={{ fontWeight: 'bold' }}>ชื่อผู้ร่วมวิจัย :</span>{' '}<span  style={{
                        color:
                            AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา' && 
                            ExJoinedData[idx]?.researcher_THname !== item?.researcher_THname
                            ? '#FFCE1B'
                            : 'black',  
                        }}>{item?.researcher_THname}</span>{' '}(<span style={{
                            color:
                                AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา' && 
                                ExJoinedData[idx]?.researcher_ENname !== item?.researcher_ENname
                                ? '#FFCE1B'
                                : 'black',  
                            }}>{item?.researcher_ENname}</span>)</p>
                    {/* <p><span style={{ fontWeight: 'bold' }}>ตำแหน่งผู้ร่วมวิจัย :</span>  {item?.posname} </p> */}
                    <p><span style={{ fontWeight: 'bold' }}>สังกัดผู้ร่วมวิจัย</span>{' '}<span  style={{
                        color:
                            AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา' && 
                            ExJoinedData[idx]?.researcher_facility !== item?.researcher_facility
                            ? '#FFCE1B'
                            : 'black',  
                        }}>{item?.researcher_facility}</span></p>
                    <p><span style={{ fontWeight: 'bold' }}>สัดส่วนภาระงานร้อยละ</span>{' '}<span  style={{
                        color:
                            AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา' && 
                            ExJoinedData[idx]?.join_per !== item?.join_per
                            ? '#FFCE1B'
                            : 'black',  
                        }}>{item?.join_per}</span></p>
                    <p><span style={{ fontWeight: 'bold' }}>เบอร์โทรศัพท์ติดต่อผู้ร่วมวิจัย</span>{' '}<span  style={{
                        color:
                            AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา' && 
                            ExJoinedData[idx]?.researcher_phone !== item?.researcher_phone
                            ? '#FFCE1B'
                            : 'black',  
                        }}>{item?.researcher_phone}</span></p>
                    <p><span style={{ fontWeight: 'bold' }}>Emailผู้ร่วมวิจัย</span>{' '}<span  style={{
                        color:
                            AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา' && 
                            ExJoinedData[idx]?.researcher_email !== item?.researcher_email
                            ? '#FFCE1B'
                            : 'black',  
                        }}>{item?.researcher_email}</span></p>
                </Card>
                <br/></>
            ))}
            <p style={{ fontWeight: 'bold' }}>สัดส่วนภาระงาน (กรณีที่มีการตีพิมพ์ในวารสาร)</p>
            {AllData?.IsJoinPer=='false'&&<Table columns={[
                {
                    title:'ลำดับ',
                    width:'5vw',
                    key:'order_id',
                    dataIndex:'order_id'
                },
                {
                    title:'ชื่อผู้มีส่วนร่วม',
                    key:'researcher_THname',
                    dataIndex:'researcher_THname'
                },
                {
                    title: 'สัดส่วนภาระงานร้อยละ',
                    key: 'join_per',
                    dataIndex: 'join_per',
                    width:'10vw',
                
                },
                ]}
                dataSource={participants}
                />||<p style={{marginLeft:20}}>ไม่สามารถจัดแบ่งได้เพราะเป็นการวิจัยแบบพหุสถาบัน/หลายประเทศ</p>
                }
                {(HeadResData?.posname!='บุคลากร'&&HeadResData?.posname!='อาจารย์')&&<><p><span style={{ fontWeight: 'bold' }}>ชื่ออาจารย์ที่ปรึกษา :</span>{' '}
                <span style={{
                    color:
                        AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา' && 
                        AllData?.advice_Name !== HisAllData?.advice_Name
                        ? '#FFCE1B'
                        : 'black',  
                    }}>{AllData?.advice_Name||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</span></p>
                <p><span style={{ fontWeight: 'bold' }}>สังกัดอาจารย์ที่ปรึกษา :</span> <span style={{
                    color:
                        AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา' && 
                        AllData?.advice_fac !== HisAllData?.advice_fac
                        ? '#FFCE1B'
                        : 'black',  
                    }}>{AllData?.advice_fac||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</span></p>
                <p><span style={{ fontWeight: 'bold' }}>เบอร์โทรศัพท์ติดต่ออาจารย์ที่ปรึกษา :</span> <span style={{
                    color:
                        AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา' && 
                        AllData?.advice_PhoneNum !== HisAllData?.advice_PhoneNum
                        ? '#FFCE1B'
                        : 'black',  
                    }}>{AllData?.advice_PhoneNum||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</span></p>
                <p><span style={{ fontWeight: 'bold' }}>Emailอาจารย์ที่ปรึกษา :</span> <span style={{
                    color:
                        AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา' && 
                        AllData?.advice_Email !== HisAllData?.advice_Email
                        ? '#FFCE1B'
                        : 'black',  
                    }}>{AllData?.advice_Email||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</span></p></>}

                <br/>
                {(HeadResData?.posname!='บุคลากร'&&HeadResData?.posname!='อาจารย์')&&<>{AllData?.IsAcademicResearch=='ใช่'&&<p>โครงการนี้เป็นโครงการวิจัยเพื่อการศึกษา</p>
                ||AllData?.IsAcademicResearch=='ไม่ใช่'&&<p>โครงการนี้ไม่เป็นโครงการวิจัยเพื่อการศึกษา</p>
                ||<p>โครงการนี้ยังไม่ระบุว่าเป็นโครงการวิจัยเพื่อการศึกษาหรือไม่</p>}</>}

                <p><span style={{ fontWeight: 'bold' }}>โครงการนี้เป็นโครงการวิจัยประเภท :</span> {' '}
                        <span
                            style={{
                            color:
                               (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                        )  &&
                                AllData?.project_type !== HisAllData?.project_type
                                ? '#FFCE1B'
                                : 'black',
                            }}
                        >
                           {AllData?.project_type||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}
                        </span></p>
                <p><span style={{ fontWeight: 'bold' }}>ผู้วิจัยมีโครงร่างงานวิจัย และแบบสอบถาม หรือเครื่องมือวิจัย เพื่อประกอบการพิจารณาจริยธรรมการวิจัยในมนุษย์หริอไม่</span></p>
                {AllData?.IsQuestionair=='ไม่มี'&&
                    <p style={{marginLeft:20}}>
                            <span
                            style={{
                            color:
                            (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                                    AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                                    AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                                    AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                                    )  &&
                                AllData?.IsQuestionair !== HisAllData?.IsQuestionair
                                ? '#FFCE1B'
                                : 'black',
                            }}
                        >
                        {AllData?.IsQuestionair}</span>{' '}เพราะ{' '}
                        <span
                        style={{
                        color:
                        (    AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                                AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                                AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                                AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                                )  &&
                            AllData?.IsQuestionairReason !== HisAllData?.IsQuestionairReason
                            ? '#FFCE1B'
                            : 'black',
                        }}
                    >{AllData?.IsQuestionairReason
                    ||<p>ยังไม่กรอก</p>}</span></p>||
                    AllData?.IsQuestionair=='มี'||
                    <p style={{marginLeft:20}}>ยังไม่กรอกข้อมูลแล้ว</p>
                }

                <br/>
                <h3>ระยะเวลา</h3>
                <Card>
                    <p>ระยะเวลาที่ดำเนินโครงการวิจัย{' '}<span
                        style={{
                        color:
                            (   AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                                AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                                AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                                AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                            )&& 
                            (
                                AllData?.ResearchPeriod_year !== HisAllData?.ResearchPeriod_year
                            )
                            ? '#FFCE1B'
                            : 'black',  
                        }}
                    >{AllData?.ResearchPeriod_year||0}</span> ปี{' '}<span
                        style={{
                        color:
                            (   AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                                AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                                AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                                AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                            )&& 
                            (
                                AllData?.ResearchPeriod_month !== HisAllData?.ResearchPeriod_month
                            )
                            ? '#FFCE1B'
                            : 'black',  
                        }}
                        >{AllData?.ResearchPeriod_month||0}</span> เดือน</p>
                    <p>
                        เริ่มตั้งแต่เดือน{' '}<span
                            style={{
                                color:
                                    (   AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                                    )&& 
                                    (
                                        AllData?.ResearchStartingDate !== HisAllData?.ResearchStartingDate
                                    )
                                    ? '#FFCE1B'
                                    : 'black',  
                                }}>
                            {
                            moment(AllData?.ResearchStartingDate).isValid()
                            ? moment(AllData?.ResearchStartingDate)
                                .add(543, 'year')
                                .format('MMMM YYYY')
                            : <span style={{ color: 'red' }}>ยังไม่กรอก</span>
                        }</span>{' '}จนถึงเดือน{' '}<span style={{
                            color:
                                (   AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                                    AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                                    AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                                    AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                                )&& 
                                (
                                    AllData?.ResearchEndingDate !== HisAllData?.ResearchEndingDate
                                )
                                ? '#FFCE1B'
                                : 'black',  
                            }}>{
                            moment(AllData?.ResearchEndingDate).isValid()
                            ? moment(AllData?.ResearchEndingDate)
                                .add(543, 'year')
                                .format('MMMM YYYY')
                            : <span style={{ color: 'red' }}>ยังไม่กรอก</span>
                        }</span>
                    </p>
                    {   (
                        AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                        )&& 
                        (HisAllData?.ResearchStartingDate!=AllData?.ResearchStartingDate||
                        HisAllData?.ResearchEndingDate!=AllData?.ResearchEndingDate)
                    &&
                        <p style={{color:'gray'}}>(ข้อมูลเดิมคือ เริ่มตั้งแต่เดือน{
                            moment(HisAllData?.ResearchStartingDate).isValid()
                            ? moment(HisAllData?.ResearchStartingDate)
                                .add(543, 'year')
                                .format('MMMM YYYY')
                            : <span style={{ color: 'red' }}>ยังไม่กรอก</span>
                        }{' '}จนถึงเดือน {moment(AllData?.ResearchEndingDate).isValid()
                            ? moment(AllData?.ResearchEndingDate).add(543, 'year').format('MMMM YYYY')
                            : <span style={{ color: 'red' }}>ยังไม่กรอก</span>
                        })</p>
                    }
                    <p>ระยะเวลาที่ดำเนินการเก็บข้อมูล{' '}<span
                            style={{
                                color:
                                    (   AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                                    )&& 
                                    (
                                        AllData?.InfoGatheringPeriod_year !== HisAllData?.InfoGatheringPeriod_year
                                    )
                                    ? '#FFCE1B'
                                    : 'black',  
                                }}>{AllData?.InfoGatheringPeriod_year||0}</span> ปี{' '}<span
                                style={{
                                    color:
                                        (   AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                                            AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                                            AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                                            AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                                        )&& 
                                        (
                                            AllData?.InfoGatheringPeriod_month !== HisAllData?.InfoGatheringPeriod_month
                                        )
                                        ? '#FFCE1B'
                                        : 'black',  
                                    }}>{AllData?.InfoGatheringPeriod_month||0}</span> เดือน</p>
                        <p>เริ่มตั้งแต่เดือน{' '}<span
                            style={{
                                color:
                                    (   AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                                    )&& 
                                    (
                                        AllData?.ResearchStartingDate !== HisAllData?.ResearchStartingDate
                                    )
                                    ? '#FFCE1B'
                                    : 'black',  
                                }}>{moment(AllData?.InfoGatheringStartingDate).isValid()
                            ? moment(AllData?.InfoGatheringStartingDate).add(543, 'year').format('MMMM YYYY')
                            : <span style={{ color: 'red' }}>ยังไม่กรอก</span>
                        }</span> จนถึงเดือน{' '}<span
                        style={{
                            color:
                                (   AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                                    AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                                    AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                                    AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                                )&& 
                                (
                                    AllData?.InfoGatheringEndingDate !== HisAllData?.InfoGatheringEndingDate
                                )
                                ? '#FFCE1B'
                                : 'black',  
                            }}>{moment(AllData?.InfoGatheringEndingDate).isValid()
                            ? moment(AllData?.InfoGatheringEndingDate).add(543, 'year').format('MMMM YYYY')
                            : <span style={{ color: 'red' }}>ยังไม่กรอก</span>
                        }</span></p>
                    {
                        (
                            AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                            AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                            AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                            AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                            )&&
                    (HisAllData?.InfoGatheringStartingDate!=AllData?.InfoGatheringStartingDate||
                        HisAllData?.InfoGatheringEndingDate!=AllData?.InfoGatheringEndingDate
                    )
                    &&
                        <p style={{color:'gray'}}>(ข้อมูลเดิมคือ เริ่มตั้งแต่เดือน{
                            moment(HisAllData?.ResearchStartingDate).isValid()
                            ? moment(HisAllData?.ResearchStartingDate)
                                .add(543, 'year')
                                .format('MMMM YYYY')
                            : <span style={{ color: 'red' }}>ยังไม่กรอก</span>
                        }{' '}จนถึงเดือน {moment(AllData?.InfoGatheringEndingDate).isValid()
                            ? moment(AllData?.InfoGatheringEndingDate).add(543, 'year').format('MMMM YYYY')
                            : <span style={{ color: 'red' }}>ยังไม่กรอก</span>
                        })</p>
                    }
                </Card>

                <br/>
                <h3>งบประมาณ</h3>
                    <p>งบประมาณโครงการวิจัย{' '}<span
                            style={{
                            color:
                            (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                                    AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                                    AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'
                                    )  &&
                                AllData?.Projectfund !== HisAllData?.Projectfund
                                ? '#FFCE1B'
                                : 'black',
                            }}
                        >{AllData?.Projectfund||'0'}</span>{' '}บาท</p>
                    <p style={{fontWeight:'bold'}}>ค่าธรรมเนียมการพิจารณาจริยธรรมฯ</p>
                    <p style={{marginLeft:20}}><span
                            style={{
                            color:
                            (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                                    AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                                    AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'
                                    )  &&
                                AllData?.EthicalApprovalFee !== HisAllData?.EthicalApprovalFee
                                ? '#FFCE1B'
                                : 'black',
                            }}
                        >{AllData?.EthicalApprovalFee||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</span></p>
                    <p style={{fontWeight:'bold'}}>แหล่งทุนสนับสนุน (Sponsor)</p>
                    <p style={{marginLeft:20}}><span
                            style={{
                            color:
                            (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                                    AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                                    AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'
                                    )  &&
                                AllData?.Sponsor !== HisAllData?.Sponsor
                                ? '#FFCE1B'
                                : 'black',
                            }}
                        >{AllData?.Sponsor&& <>{
                            AllData?.Sponsor=='อื่นๆ'&&<>{AllData?.SponsorNote}</>||<>{AllData?.Sponsor}</>
                        }
                    </>||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</span></p>
                    <p style={{color:'gray',marginLeft:20}}>หมายเหตุ : <span
                            style={{
                            color:
                            (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                                    AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                                    AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'
                                    )  &&
                                AllData?.SponsorNote !== HisAllData?.SponsorNote
                                ? '#FFCE1B'
                                : 'black',
                            }}
                        >{AllData?.SponsorNote||<span style={{color:'red'}}>ไม่มีข้อมูล</span>}</span></p>


            </Card>
            <br/>
            <div id="part1-2"/>
            <Card>
                <h2>1.2 การพิจารณาจริยธรรม</h2>
                <Card>
            <p>ผู้ที่จะได้รับเชิญเป็นผู้ร่วมโครงการวิจัย</p>
            {   ((NewinvitedParticipant.normal&&NewinvitedParticipant.normal.count!=null)
                        ||(NewinvitedParticipant.kids&&NewinvitedParticipant.kids?.count!=null)
                        ||(NewinvitedParticipant.vulnerable&&NewinvitedParticipant.vulnerable.count!=null))
                        &&
                            <>
                                    {(NewinvitedParticipant.normal&&NewinvitedParticipant.normal.count!=null)&&
                                <>
                                <Card>
                                    <h3>อาสาสมัครทั่วไป</h3>
                                    <p> <span style={{ fontWeight: 'bold', width: '5vw' }}>จำนวน</span> {' '}<span
                                        style={{
                                            color:
                                            (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                                            AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                                            AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                                            AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                                            )  &&
                                            (
                                                !NewinvitedParticipantHistory || 
                                                NewinvitedParticipantHistory.normal?.count !== NewinvitedParticipant.normal?.count
                                            )
                                                ? '#FFCE1B'
                                                : 'black',
                                        }}
                                        >{NewinvitedParticipant.normal.count}</span> คน</p>
                                        <p><span style={{fontWeight:'bold'}}>อายุ :</span> 
                                        <span
                                            style={{
                                                color:
                                                (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                                                AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                                                AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                                                AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                                                )  &&
                                                    (
                                                        !NewinvitedParticipantHistory || 
                                                        NewinvitedParticipantHistory.normal?.age !== NewinvitedParticipant.normal.age
                                                    )
                                                        ? '#FFCE1B'
                                                        : 'black',
                                                }}>{NewinvitedParticipant.normal.age}</span> </p>
                                            <p>
                                                <span style={{fontWeight:'bold'}}>เพศ</span>{' '}<span
                                                    style={{
                                                        color:
                                                        (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                                                            AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                                                            AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                                                            AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                                                            )  &&
                                                            !arraysHaveSameMembers(
                                                                NewinvitedParticipant.normal?.gender || [],
                                                                NewinvitedParticipantHistory.normal?.gender || []
                                                                )
                                                        
                                                            ? '#FFCE1B'
                                                            : 'black',
                                                    }}>{NewinvitedParticipant.normal.gender.join(', ')}</span>
                                            </p>
                                            <p> <span style={{fontWeight:'bold'}}>หมายเหตุ</span>{' '}<span
                                                style={{
                                                    color:
                                                    (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                                                    AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                                                    AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                                                    AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                                                    )  &&
                                                    (
                                                        !NewinvitedParticipantHistory.normal || 
                                                        NewinvitedParticipantHistory.normal.note !== NewinvitedParticipant.normal.note
                                                    )
                                                        ? '#FFCE1B'
                                                        : 'black',
                                                }}>{NewinvitedParticipant.normal.note}</span></p>
                                        </Card>
                                <br/></>
                                    }

                                      {(NewinvitedParticipant.kids&&NewinvitedParticipant.kids?.count!=null)&&
                                <>
                                <Card>
                                    <h3>อาสาสมัครเด็ก อายุ 7-18 ปี</h3>
                                    <p> <span style={{ fontWeight: 'bold', width: '5vw' }}>จำนวน</span> {' '}<span
                                        style={{
                                            color:
                                            (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                                            AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                                            AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                                            AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                                            )  &&
                                            (
                                                !NewinvitedParticipantHistory || 
                                                NewinvitedParticipantHistory.kids?.count !== NewinvitedParticipant.kids?.count
                                            )
                                                ? '#FFCE1B'
                                                : 'black',
                                        }}
                                        >{NewinvitedParticipant.kids?.count}</span> คน</p>
                                        <p><span style={{fontWeight:'bold'}}>อายุ :</span> 
                                        <span
                                            style={{
                                                color:
                                                (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                                                AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                                                AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                                                AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                                                )  &&
                                                    (
                                                        !NewinvitedParticipantHistory || 
                                                        NewinvitedParticipantHistory.kids?.age !== NewinvitedParticipant.kids?.age
                                                    )
                                                        ? '#FFCE1B'
                                                        : 'black',
                                                }}>{NewinvitedParticipant.kids?.age}</span> </p>
                                            <p>
                                                <span style={{fontWeight:'bold'}}>เพศ</span>{' '}<span
                                                    style={{
                                                        color:
                                                        (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                                                            AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                                                            AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                                                            AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                                                            )  &&
                                                            !arraysHaveSameMembers(
                                                                NewinvitedParticipant.kids?.gender || [],
                                                                NewinvitedParticipantHistory.kids?.gender || []
                                                                )
                                                        
                                                            ? '#FFCE1B'
                                                            : 'black',
                                                    }}>{NewinvitedParticipant.kids?.gender.join(', ')}</span>
                                            </p>
                                            <p> <span style={{fontWeight:'bold'}}>หมายเหตุ</span>{' '}<span
                                                style={{
                                                    color:
                                                    (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                                                    AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                                                    AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                                                    AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                                                    )  &&
                                                    (
                                                        !NewinvitedParticipantHistory.kids || 
                                                        NewinvitedParticipantHistory.kids.note !== NewinvitedParticipant.kids?.note
                                                    )
                                                        ? '#FFCE1B'
                                                        : 'black',
                                                }}>{NewinvitedParticipant.kids?.note}</span></p>
                                        </Card>
                                <br/></>
                                    }
                                     {(NewinvitedParticipant.vulnerable&&NewinvitedParticipant.vulnerable?.count!=null)&&
                                <>
                                <Card>
                                    <h3>อาสาสมัครกลุ่มเปราะบาง</h3>
                                    <p> <span style={{ fontWeight: 'bold', width: '5vw' }}>จำนวน</span> {' '}<span
                                        style={{
                                            color:
                                            (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                                            AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                                            AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                                            AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                                            )  &&
                                            (
                                                !NewinvitedParticipantHistory || 
                                                NewinvitedParticipantHistory.vulnerable?.count !== NewinvitedParticipant.vulnerable?.count
                                            )
                                                ? '#FFCE1B'
                                                : 'black',
                                        }}
                                        >{NewinvitedParticipant.vulnerable?.count}</span> คน</p>
                                        <p><span style={{fontWeight:'bold'}}>อายุ :</span> 
                                        <span
                                            style={{
                                                color:
                                                (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                                                AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                                                AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                                                AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                                                )  &&
                                                    (
                                                        !NewinvitedParticipantHistory || 
                                                        NewinvitedParticipantHistory.vulnerable?.age !== NewinvitedParticipant.vulnerable?.age
                                                    )
                                                        ? '#FFCE1B'
                                                        : 'black',
                                                }}>{NewinvitedParticipant.vulnerable?.age}</span> </p>
                                            <p>
                                                <span style={{fontWeight:'bold'}}>เพศ</span>{' '}<span
                                                    style={{
                                                        color:
                                                        (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                                                            AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                                                            AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                                                            AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                                )  &&
                                !arraysHaveSameMembers(
                                    NewinvitedParticipant.vulnerable?.gender || [],
                                    NewinvitedParticipantHistory.vulnerable?.gender || []
                                    )
                            
                                ? '#FFCE1B'
                                : 'black',
                        }}>{NewinvitedParticipant.vulnerable?.gender.join(', ')}</span>
                                </p>
                                <p> <span style={{fontWeight:'bold'}}>หมายเหตุ</span>{' '}<span
                                    style={{
                                        color:
                                        (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'||
                                        AllData?.project_status === 'รอพิจารณาผลการแก้ไขจากกรรมการ'
                                        )  &&
                                        (
                                            !NewinvitedParticipantHistory.vulnerable || 
                                            NewinvitedParticipantHistory.vulnerable.note !== NewinvitedParticipant.vulnerable?.note
                                        )
                                            ? '#FFCE1B'
                                            : 'black',
                                    }}>{NewinvitedParticipant.vulnerable?.note}</span></p>
                                </Card>
                                <br/></>
                                    }
                            </>
                            ||<>
                                <Card>
                                    <p style={{color:'red'}}>ยังไม่มีการเพิ่มข้อมูล</p>
                                </Card></>}
                 </Card>
                <br/>
                <p  style={{fontWeight:'bold'}}>การเจาะเลือดผู้ป่วย/อาสาสมัครหริอไม่ </p>
        <div style={{ marginLeft: 20 }}>
            <span style={{
                color:
                   (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'
                        )  &&
                    AllData?.IsbloodDraw !== HisAllData?.IsbloodDraw
                    ? '#FFCE1B'
                    : 'black',
                }}>
            {AllData?.IsbloodDraw === 'มี' ? (
                <p>มี มีรายละเอียดดังนี้</p>
            ) : AllData?.IsbloodDraw ? (
                <p>{AllData.IsbloodDraw}</p>
            ) : (
                <p style={{ color: 'red' }}>ยังไม่มีการลงข้อมูล</p>
            )}</span>
            </div>
        {AllData?.IsbloodDraw=='มี'&&
            <Card style={{marginLeft:20}}>
                <p style={{fontWeight:'bold'}}>วัตถุประสงค์ของการเจาะเลือด</p>
                <span
                    style={{
                        color:
                           (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'
                        )  &&
                            AllData?.bloodDrawObjective !== HisAllData?.bloodDrawObjective
                            ? '#FFCE1B'
                            : 'black',
                        }}>
                    <p
                        style={{ fontSize: '16px', marginLeft: 20 }}
                        dangerouslySetInnerHTML={{ 
                            __html: (AllData?.bloodDrawObjective || 'ยังไม่กรอกข้อมูล').replace(/\n/g, '<br/>') 
                        }}
                        /></span>
                <Row>
                    <Col span={12}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span style={{ fontWeight: 'bold', width: '5vw' }}>จำนวน</span>
                        <span style={{
                            color:
                               (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                            AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                            AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'
                            )  &&
                                AllData?.bloodDrawTimes !== HisAllData?.bloodDrawTimes
                                ? '#FFCE1B'
                                : 'black',
                            }}>{AllData?.bloodDrawTimes}</span>
                        <span style={{ fontWeight: 'bold', marginLeft: '3vw' }}>ครั้ง</span>
                        </div>
                    </Col>
                    <Col span={12}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span style={{ fontWeight: 'bold', width: '5vw' }}>ครั้งละ</span>
                        <span  style={{
                            color:
                               (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'
                        )  &&
                                AllData?.bloodDrawAmount !== HisAllData?.bloodDrawAmount
                                ? '#FFCE1B'
                                : 'black',
                            }}>{AllData?.bloodDrawAmount}</span>
                        <span style={{ color:
                               (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'
                        )  &&
                                AllData?.bloodDrawUnit !== HisAllData?.bloodDrawUnit
                                ? '#FFCE1B'
                                : 'black',fontWeight: 'bold', marginLeft: '3vw' }}>{AllData?.bloodDrawUnit|| 'ยังไม่กรอก'}</span>
                        </div>
                    </Col>
                    </Row>

                    <Row>
                    <Col span={12}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span style={{ fontWeight: 'bold', width: '5vw' }}>ทั้งหมด</span>
                        <span style={{
                            color:
                               (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'
                        )  &&
                                AllData?.bloodDrawTotalTimes !== HisAllData?.bloodDrawTotalTimes
                                ? '#FFCE1B'
                                : 'black',
                            }}>{AllData?.bloodDrawTotalTimes}</span>
                        <span style={{ fontWeight: 'bold', marginLeft: '3vw' }}>ครั้ง</span>
                        </div>
                    </Col>
                    <Col span={12}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span style={{ fontWeight: 'bold', width: '5vw' }}>ต่อ</span>
                        <span style={{
                            color:
                               (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'
                        )  &&
                                AllData?.bloodDrawTotalMonth !== HisAllData?.bloodDrawTotalMonth
                                ? '#FFCE1B'
                                : 'black',
                            }}>{AllData?.bloodDrawTotalMonth}</span>
                        <span style={{ fontWeight: 'bold', marginLeft: '3vw' }}>เดือน</span>
                        </div>
                    </Col>
                    </Row>

               
            </Card>}
            <p  style={{fontWeight:'bold'}}>หัตถการอื่นที่มีการรุกล้ำร่างกาย (Invasive Procedure)  </p>
                <div style={{ marginLeft: 20 }}>
                    <span
                        style={{
                        color:
                        (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                                AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                                AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'
                                )  &&
                            AllData?.IsInvasiveProcedure !== HisAllData?.IsInvasiveProcedure
                            ? '#FFCE1B'
                            : 'black',
                        }}
                    >
                        {AllData?.IsInvasiveProcedure === 'มี' ? (
                            <p>มี มีรายละเอียดดังนี้</p>
                        ) : AllData?.IsInvasiveProcedure ? (
                            <p>{AllData.IsInvasiveProcedure}</p>
                        ) : (
                            <span style={{ color: 'red' }}>ยังไม่มีการลงข้อมูล</span>
                        )}</span>
                </div>
                {AllData?.IsInvasiveProcedure == 'มี'&&
                <Card style={{marginLeft:20}}>
                    <span
                        style={{
                        color:
                        (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                                AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                                AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'
                                )  &&
                            AllData?.InvasiveProcedureSummary !== HisAllData?.InvasiveProcedureSummary
                            ? '#FFCE1B'
                            : 'black',
                        }}
                    >
                    <p
                        style={{ fontSize: '16px', marginLeft: 20 }}
                        dangerouslySetInnerHTML={{ 
                            __html: (AllData?.InvasiveProcedureSummary || 'ยังไม่กรอกข้อมูล').replace(/\n/g, '<br/>') 
                        }}
                        /></span>
                </Card>
                }
          
                <p  style={{fontWeight:'bold'}}>ความเสี่ยงและความไม่สะดวกสบายที่ผู้ป่วย/อาสาสมัคร จะได้รับจากการร่วมโครงการ</p>
                <p style={{marginLeft:20}}><span
                    style={{
                    color:
                    (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                            AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                            AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'
                            )  &&
                        AllData?.RiskAndUncomfortableFactor !== HisAllData?.RiskAndUncomfortableFactor
                        ? '#FFCE1B'
                        : 'black',
                    }}
                >{AllData?.RiskAndUncomfortableFactor||<span style={{color:'red'}}>ยังไม่มีการลงข้อมูล</span>}</span></p>
                <p style={{fontWeight:'bold'}}>วิธีการหรือมาตรการที่จัดเตรียมเพื่อลดความเสี่ยงและความไม่สะดวกสบายที่ผู้ป่วย/อาสาสมัคร จะได้รับจากการร่วมโครงการ </p>
                <p style={{marginLeft:20}}><span
                style={{
                color:
                   (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'
                        )  &&
                    AllData?.DefensiveMeasure !== HisAllData?.DefensiveMeasure
                    ? '#FFCE1B'
                    : 'black',
                }}
            >{AllData?.DefensiveMeasure||<span style={{color:'red'}}>ยังไม่มีการลงข้อมูล</span>}</span></p>
                <p style={{fontWeight:'bold'}}>ถ้าหากเกิดอันตราย/ความเสียหายต่อผู้ถูกวิจัย ที่เป็นผลสืบเนื่องโดยตรงจากการวิจัยในผู้ป่วย ผู้เสนอโครงการและ/หรือผู้ให้ทุนสนับสนุน
                    การวิจัยจะให้การรักษาจนกลับคืนสภาพเดิม หรือชดเชยความเสียหายที่ไม่สามารถรักษาให้คืนสู่สภาพเดิมได้ ตลอดจน
                    ให้ความคุ้มครองด้านค่าใช้จ่ายแก่ผู้ถูกวิจัยอย่างไรบ้าง?</p>
                    <p style={{marginLeft:20}}>{AllData?.ExpenseCoverage||<span style={{color:'red'}}>ยังไม่มีการลงข้อมูล</span>}</p>
                
                <p style={{fontWeight:'bold'}}>ผู้วิจัยและผู้ร่วมงานทุกคนในโครงการทราบโดยผ่านการอบรมจริยธรรมการวิจัยในมนุษย์และเข้าใจข้อตกลง หลักความเคารพ
                ในบุคคล หลักคุณประโยชน์ และหลักความยุติธรรม  หรือไม่ </p>
                <p style={{marginLeft:20}}>{AllData?.AcceptanceUnderstanding||<span style={{color:'red'}}>ยังไม่มีการลงข้อมูล</span>}</p>
                <p style={{fontWeight:'bold'}}>โครงการวิจัยเกี่ยวข้องหรืออาจมีผลกระทบกระเทือนต่อศาสนา ความเชื่อ ขนบธรรมเนียมประเพณี หรือ วัฒนธรรมอันดีงามของประเทศไทย หรือของท้องถิ่นที่ทำการวิจัยอยู่หรือไม่</p>
                <p style={{marginLeft:20}}>{AllData?.IsCountryReligionRiskFactor||<span style={{color:'red'}}>ยังไม่มีการลงข้อมูล</span>}</p>
                {AllData?.IsInvasiveProcedure&&<>
                    <p style={{marginLeft:20}}>หมายเหตุ :  {AllData?.CountryReligionRiskFactor}</p></>
                }
                <br/>
            </Card>
            <br/>
            <div id="part1-3"/>
            <Card>
                <h2>1.3 ยา</h2>
                <p style={{fontWeight:'bold'}}>โครงการวิจัยนี้มีการให้ยาและหรือสิ่งทดลอง (เช่น โปรแกรมการส่งเสริมสุขภาพ การนวด การใช้สมุนไพร เป็นต้น) แก่ผู้ป่วย/อาสาสมัครหรือไม่ </p>
                <p style={{marginLeft:20}}><span
                        style={{
                        color:
                        (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                                AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                                AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'
                                )  &&
                            AllData?.IsMedicine !== HisAllData?.IsMedicine
                            ? '#FFCE1B'
                            : 'black',
                        }}
                    >{AllData?.IsMedicine&&<>
                    {AllData?.MedicineInfo&&<p>{AllData?.IsMedicine} <span>:: </span><span
                        style={{
                        color:
                        (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                                AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                                AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'
                                )  &&
                            AllData?.MedicineInfo !== HisAllData?.MedicineInfo
                            ? '#FFCE1B'
                            : 'black',
                        }}
                    >{AllData?.MedicineInfo}</span></p>}
                    </> ||<span style={{color:'red'}}>ยังไม่มีการลงข้อมูล</span>}</span></p>
                <span style={{
                        color:
                        (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                                AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                                AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'
                                )  &&
                            AllData?.applicableFactor !== HisAllData?.applicableFactor
                            ? '#FFCE1B'
                            : 'black',
                        }}>{AllData?.applicableFactor!='ไม่เกี่ยวข้องกับรายการข้างต้น'&&<p  style={{fontWeight:'bold'}}>โครงการวิจัยนี้เกี่ยวข้องกับ </p>}
                {AllData?.applicableFactor && AllData.applicableFactor !== "[]" ? (
                    <div style={{ marginLeft: 20 }}>
                        {JSON.parse(AllData.applicableFactor).map((item:any, idx:any) => (
                        <div key={idx}>- {item}</div>
                        ))}
                    </div>
                    ) : (
                    <p style={{ marginLeft: 20, color: 'red' }}>ยังไม่กรอกข้อมูล</p>
                    )}</span>
                {AllData?.applicableFactorDesc&&<p style={{marginLeft:20}}>คำอธิบายประกอบ : <span style={{color:
                        (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                                AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                                AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'
                                )  &&
                            AllData?.applicableFactorDesc !== HisAllData?.applicableFactorDesc
                            ? '#FFCE1B'
                            : 'black',}}>{AllData?.applicableFactorDesc}</span></p>}
            </Card>
            <br/>
            <div id="part1-4"/>
            <Card>
                <h2>1.4 ทรัพย์สินทางปัญญาและอื่น ๆ</h2>

                <p style={{fontWeight:'bold'}}>ผลของการศึกษาวิจัย (Results) หรือวัสดุใด ๆ (Materials) ที่เก็บจากผู้ป่วยหรือที่จะเป็นผลลัพธ์จากการวิจัยอาจมีคุณค่าในแง่ทรัพย์สินทาง
                การค้าและ/หรือทรัพย์สินทางปัญญา (เช่น สิทธิบัตร) หรือไม่ อย่างไร </p>
                <span style={{
                color:
                (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                                AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                                AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'
                                )  &&
                AllData?.IsCommercialInterlectualProperty !== HisAllData?.IsCommercialInterlectualProperty
                ? '#FFCE1B'
                : 'black',
                }}>
                {AllData?.IsCommercialInterlectualProperty=='มี'&&<p style={{marginLeft:20}}>มี ดังนี้ {AllData?.ComIntDesc}</p>|| 
                <p style={{marginLeft:20}}>{AllData?.IsCommercialInterlectualProperty ||
                    <span style={{color:'red'}}>ยังไม่มีการลงข้อมูล</span>}</p>}</span>
                <p style={{fontWeight:'bold'}}>ผู้วิจัยจะส่งรายงานความก้าวหน้า (Progress Report) มายังคณะกรรมการเมื่อ</p>
                <span style={{
                color:
                (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                                AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                                AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'
                                )  &&
                AllData?.ProgressReport !== HisAllData?.ProgressReport
                ? '#FFCE1B'
                : 'black',
                }}>
                    <p style={{marginLeft:20}}>{AllData?.ProgressReport||<span style={{color:'red'}}>ยังไม่มีการลงข้อมูล</span>}</p>
                </span>
                <p style={{fontWeight:'bold'}}>การเขียนทบทวนวรรณกรรม การนำผลงาน ข้อความ หรือความคิดเห็นของผู้อื่น มาดัดแปลง ตัดต่อ หรือแก้ไข (บางส่วนหรือทั้งหมด) ทำซ้ำกับบุคคลอื่น ไม่เกิน 30 %  </p>
                <span style={{
                color:
                (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                                AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                                AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'
                                )  &&
                AllData?.PlagiarismPer !== HisAllData?.PlagiarismPer
                ? '#FFCE1B'
                : 'black',
                }}>{AllData?.PlagiarismPer=='ไม่ใช่'&&<p  style={{marginLeft:20}}>{AllData?.PlagiarismPer} เพราะ <span style={{
                    color:
                (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                                AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                                AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'
                                )  &&
                    AllData?.PlagiarismDesc !== HisAllData?.PlagiarismDesc
                    ? '#FFCE1B'
                    : 'black',
                }}>{AllData?.PlagiarismDesc||<span style={{color:'red'}}>ยังไม่มีการลงข้อมูล</span>}</span> </p>}
                {AllData?.PlagiarismPer=='ใช่'&&<p  style={{marginLeft:20}}>{AllData?.PlagiarismPer} </p>}</span>
                {!AllData?.PlagiarismPer&&<p  style={{marginLeft:20}}><span style={{color:'red'}}>ยังไม่มีการลงข้อมูล</span> </p>}
            </Card>
            <br/>
            <div id="part1-5"/>
            <Card>
        <h2>1.5 คำรับรองจากผู้วิจัย</h2>
        {AllData?.Acceptance=='รับรอง'
        &&<>
        <p>ในการดำเนินการวิจัยในครั้งนี้ ข้าพเจ้าขอรับรองว่า</p>
        <p>1. ข้าพเจ้าได้ตรวจสอบความถูกต้องของข้อมูลทั้งหมดที่นำเสนอต่อคณะกรรมการจริยธรรมการวิจัยในมนุษย์ มหาวิทยาลัยวงษ์ชวลิตกุลด้วยตนเอง</p>
        <p>2. ข้าพเจ้าจะไม่เริ่มดำเนินการวิจัยจนกว่าจะได้รับผลการพิจารณาจากคณะกรรมการจริยธรรมการวิจัยในมนุษย์ มหาวิทยาลัยวงษ์ชวลิตกุล </p>
        <p>3. ข้าพเจ้าทราบว่าหากมีการแก้ไข/ปรับปรุงโครงการวิจัย นอกเหนือจากที่ยื่นขอรับการพิจารณาครั้งนี้ ข้าพเจ้าจะต้องรายงาน โดยใช้แบบฟอร์ม มว.จ.011 หรือ มว.จ.012 หรือ มว.จ.013 </p>
        <p>4. ข้าพเจ้าจะรายงานการแจ้งปิดโครงการวิจัยต่อคณะกรรมการจริยธรรมการวิจัยในมนุษย์ มหาวิทยาลัยวงษ์ชวลิตกุล โดยใช้แบบฟอร์ม มว.จ.016  เมื่อดำเนินโครงการวิจัยเสร็จสิ้นแล้ว</p></>
        ||AllData?.Acceptance=='ไม่รับรอง'
        &&<div><p  style={{color:'red'}}>ในการดำเนินการวิจัยในครั้งนี้ ข้าพเจ้าไม่รับรองว่า</p>
        <p>1. ข้าพเจ้าได้ตรวจสอบความถูกต้องของข้อมูลทั้งหมดที่นำเสนอต่อคณะกรรมการจริยธรรมการวิจัยในมนุษย์ มหาวิทยาลัยวงษ์ชวลิตกุลด้วยตนเอง</p>
        <p>2. ข้าพเจ้าจะไม่เริ่มดำเนินการวิจัยจนกว่าจะได้รับผลการพิจารณาจากคณะกรรมการจริยธรรมการวิจัยในมนุษย์ มหาวิทยาลัยวงษ์ชวลิตกุล </p>
        <p>3. ข้าพเจ้าทราบว่าหากมีการแก้ไข/ปรับปรุงโครงการวิจัย นอกเหนือจากที่ยื่นขอรับการพิจารณาครั้งนี้ ข้าพเจ้าจะต้องรายงาน โดยใช้แบบฟอร์ม มว.จ.011 หรือ มว.จ.012 หรือ มว.จ.013 </p>
        <p>4. ข้าพเจ้าจะรายงานการแจ้งปิดโครงการวิจัยต่อคณะกรรมการจริยธรรมการวิจัยในมนุษย์ มหาวิทยาลัยวงษ์ชวลิตกุล โดยใช้แบบฟอร์ม มว.จ.016  เมื่อดำเนินโครงการวิจัยเสร็จสิ้นแล้ว</p>
        </div>
        ||
        <><p>ยังไม่มีการยืนยันคำรับรองจากนักวิจัย</p></>}
        <p>ข้าพเจ้าต้องการหนังสือรับรองจากคณะกรรมการเป็นฉบับ</p>
        <Card>
        {AllData?.LangRecieve && AllData.LangRecieve !== "[]" ? (
            JSON.parse(AllData.LangRecieve).join(", ")
        ) : (
            <span style={{ color: 'red' }}>ยังไม่ระบุ</span>
        )}</Card>
    </Card>
            <br/><hr/>
            <div id="part2"/>
            <h2>ส่วนที่ 2 แบบเอกสารชี้แจงอาสาสมัคร เพื่อประกอบการพิจารณาจริยธรรมการวิจัยในมนุษย์</h2>
            <Card>
        <p> <span style={{ fontWeight: 'bold' }}>ชื่อโครงการวิจัย : </span>{AllData?.project_nameTH||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</p>
        <Card>
        <p> <span style={{ fontWeight: 'bold' }}>ชื่อผู้วิจัย : </span>{HeadResData?.researcher_THname}</p>
        <p> <span style={{ fontWeight: 'bold' }}>ตำแหน่ง : </span>{HeadResData?.posname || <span style={{color:'red'}}>ไม่มีข้อมูล</span>}</p>
        <p> <span style={{ fontWeight: 'bold' }}>สถานที่ติดต่อผู้วิจัย (ที่ทำงาน) : </span>{HeadResData?.researcher_wp||'ยังไม่มีข้อมูล'}</p>
        <p> <span style={{ fontWeight: 'bold' }}>สถานที่ติดต่อผู้วิจัย (บ้าน) : </span>{HeadResData?.researcher_address||'ยังไม่มีข้อมูล'}</p>
        <p> <span style={{ fontWeight: 'bold' }}>โทรศัพท์ (ที่ทำงาน) : </span>{HeadResData?.researcher_wptel||'ยังไม่มีข้อมูล'}</p>
        <p> <span style={{ fontWeight: 'bold' }}>โทรศัพท์ (บ้าน) : </span>{HeadResData?.researcher_tel||'ยังไม่มีข้อมูล'}</p>
        <p> <span style={{ fontWeight: 'bold' }}>โทรศัพท์ (มือถือ) : </span>{HeadResData?.researcher_phone||'ยังไม่มีข้อมูล'}</p>
        <p> <span style={{ fontWeight: 'bold' }}>E-mail : </span>{HeadResData?.researcher_email||'ยังไม่มีข้อมูล'}</p>
        </Card>
       
        <hr/>
        <p> <span style={{ fontWeight: 'bold' }}>โครงการวิจัยนี้เกี่ยวข้องกับการวิจัย เรื่อง</span> </p>
        <p style={{marginLeft:20}}>{AllData?.relevantTopic}</p>
        <p> <span style={{ fontWeight: 'bold' }}>วัตถุประสงค์ของการวิจัย</span> </p>
        <p style={{marginLeft:20}}>{AllData?.Objective}</p>
        <Card>
            <p style={{fontWeight:'bold'}}><u>รายละเอียดของกลุ่มประชากร/กลุ่มตัวอย่าง/ผู้มีส่วนร่วมในการวิจัย </u></p>
            <p style={{marginLeft:20}}>ลักษณะของกลุ่มประชากร/กลุ่มตัวอย่าง/ผู้มีส่วนร่วมในการวิจัย  เกณฑ์การคัดเข้า และเกณฑ์การคัดออก: </p>
            <p style={{color:
                        (AllData?.project_status === 'แก้ไขข้อมูลตามผลพิจารณา'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากเจ้าหน้าที่'||
                        AllData?.project_status === 'รอตรวจสอบผลการแก้ไขจากประธาน'
                        )  &&
                        AllData?.ParticipantCharacteristicAndCriterion !== HisAllData?.ParticipantCharacteristicAndCriterion
                        ? '#FFCE1B'
                        : 'black',marginLeft:40}}
                        dangerouslySetInnerHTML={{
                            __html: (AllData?.ParticipantCharacteristicAndCriterion || 'ยังไม่กรอกข้อมูล').replace(/\r\n|\n|\r/g, '<br/>'),
                          }}></p>

            <p style={{marginLeft:20}}>จำนวนของกลุ่มประชากร/กลุ่มตัวอย่าง/ผู้มีส่วนร่วมในการวิจัย: </p>
            <ROCKEditors
                myRef={ParticipantAmountRef}
                htmlBox={AllData?.ParticipantAmount ? AllData?.ParticipantAmount : "ยังไม่กรอกข้อมูล"}
                toolstate={false}
                />
            
            <p style={{marginLeft:20}}>วิธีการได้มาซึ่งกลุ่มประชากร/กลุ่มตัวอย่าง/ผู้มีส่วนร่วมในการวิจัย: </p>
            <p style={{marginLeft:40}}>{AllData?.ParticipantRecruit||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</p>

            <p style={{marginLeft:20}}>เหตุผลที่ได้รับเชิญเข้าร่วมโครงการวิจัย: </p>
            <p style={{marginLeft:40}}>{AllData?.ParticipantReason||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</p>

            <p style={{fontWeight:'bold'}}>กระบวนการการวิจัยที่กระทำต่อกลุ่มประชากร/กลุ่มตัวอย่าง/ผู้มีส่วนร่วมในการวิจัย </p>
            {(AllData?.ParticipantProcedure!=HisAllData?.ParticipantProcedure &&HisAllData)&&<>
                    <br/><Card>
                    <p style={{color:'rec'}}>ข้อมูลการแบ่งกลุ่มประชากร/กลุ่มตัวอย่าง/ผู้มีส่วนร่วมในการวิจัยมีการเปลี่ยนแปลงเป็นผลดั่งด้านล่าง</p>
                    เหตุผลที่ได้รับเชิญเข้าร่วมโครงการวิจัย    </Card><br/></>}
                <ROCKEditors
                    myRef={ParticipantProcedureRef}
                    htmlBox={AllData?.ParticipantProcedure ? AllData?.ParticipantProcedure : "ยังไม่กรอกข้อมูล"}
                    toolstate={false}
                    />

              </Card>
     

              <p style={{fontWeight:'bold'}}>กระบวนการให้ข้อมูลแก่กลุ่มประชากร หรือผู้มีส่วนร่วมในการวิจัย </p>
              <p style={{marginLeft:20}}>{AllData?.ParticipantAcknowledgementMethod||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</p>

              <Card>
                  <p style={{fontWeight:'bold'}}>การใช้เวชระเบียน </p>
                  <p style={{marginLeft:20}}>การวิจัยที่ดูข้อมูลจากเวชระเบียนเท่านั้น ต้องได้รับการอนุมัติจากผู้มีอำนาจหน้าที่ เช่น ผู้อำนวยการโรงพยาบาล </p>
                  <p style={{marginLeft:40}}>{AllData?.MedicalRecordInfoAllowedByHead||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</p>
                  <p style={{marginLeft:20}}>การวิจัยที่มีการกระทำต่อผู้ป่วยและใช้เวชระเบียนต้องได้รับการอนุมัติจากผู้มีอำนาจหน้าที่ เช่น ผู้อำนวยการโรงพยาบาลและการยินยอมจากผู้ป่วย: </p>
                  <p style={{marginLeft:40}}>{AllData?.MedicalRecordactionAllowedByHead||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</p>
              </Card>
              <p style={{fontWeight:'bold'}}>ข้อมูลเกี่ยวกับอันตรายหรือความเสี่ยงที่อาจเกิดขึ้นแก่กลุ่มประชากร/กลุ่มตัวอย่าง/ผู้มีส่วนร่วมในการวิจัย รวมทั้งวิธีการป้องกัน/ปกป้องอันตราย และความเสี่ยงนั้น </p>
              <p style={{marginLeft:20}}>{AllData?.RiskAndPrevent||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</p>

              <p style={{fontWeight:'bold'}}>ประโยชน์ในการเข้าร่วมวิจัย: </p>
              <p style={{marginLeft:20}}>{AllData?.Benefit||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</p>

              <p style={{fontWeight:'bold'}}>การจ่ายค่าพาหนะ ค่าชดเชยการเสียเวลา หรือของที่ระลึก: </p>
              <p style={{marginLeft:20}}>{AllData?.Coverage||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</p>
            </Card>
            <br/>
            <Flex justify='center'>
                <Button type="primary" icon={<UploadOutlined />} onClick={() => {
                    window.open(`${process.env.REACT_APP_BASE}/generate-alldataPDF/${sessionStorage.getItem('Order_ID')}/${AllData?.head_ID}`);
                    }}>
                    ดาวน์โหลดข้อมูลโครงการ
                </Button>
            </Flex>
            <br/>
            <hr/>
    <div id="part3"/>
    <h2>ส่วนที่ 3 แนบเอกสารหลักฐานเพิ่มเติม</h2>
    <Table
        rowClassName={() => 'centered-row'}
        columns={[{
                title:'ลำดับ',
                width:'2vw',
                dataIndex:'id',
                
            },{
                title:'ประเภทเอกสาร',
                dataIndex:'AttachmentType',
                render:(__, record)=> <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center', 
                        height: '100%', 
                    }}
                >
                    {record.Status === 'แนบแล้ว' ? (
                        <a onClick={() => viewFile(record.AttachmentType)}>{record.AttachmentType}</a>
                    ) : (
                        <p style={{marginTop:0,marginBottom:0}}>{record.AttachmentType}</p>
                    )}
                  
              </div>
            },{
                title:'สถานะเอกสาร',
                dataIndex:'Status',
                render:(__, record)=> <>
                    {record.Status=='แนบแล้ว'&&<p>{record.Status}</p>||
                    <p style={{color:'red'}}>ไม่ได้แนบไฟล์</p>}
                </>
            }
        ]}
        pagination={false}
        dataSource={FileAttachment}/>

        <Modal
        open={ShowFile}
        width={'70vw'}
        onCancel={()=>{
            setShowFile(false);
            setPreviewUrl(null);
        }}
        footer={<></>}
        >
            <h2>ข้อมูลเอกสาร</h2>
            <hr/>
            {<>{previewUrl ? (
                <iframe
                    src={previewUrl}
                    width="100%"
                    height="600px"
                    title="PDF Viewer"
                />
                ) : (
                <p>Loading...</p>
                )}</>}
                        
    </Modal>
    <Modal
        open={ShowMultipleFiles}
        onCancel={()=>{
            setShowMultipleFiles(false);
            setPreviewUrl(null);}}
        width={'70vw'}
        footer={<></>}
        >
        <h2>ข้อมูลเอกสาร</h2>
        <hr/>
        <List 
            pagination={{
                position: 'bottom',      
                align: 'end',            
                pageSize: 5,             
                showSizeChanger: true,   
                showQuickJumper: true    
              }}
              dataSource={SubFileList}
              renderItem={(item, index) =>(
                <><List.Item
                    actions={[<a onClick={()=>ViewTool(item.FileID)}>ดูไฟล์</a> ]}>
                    <List.Item.Meta
                        title={<p>{item.FileName}</p>}
                       />
                </List.Item>
                    <br/>
                  
                </>
              )}
            />
            <br/>
            <Flex justify='center'>
              {
                previewUrl&&<>
                    {
                        FileType=='application/pdf'&&
                        <iframe
                            src={previewUrl}
                            width="80%"
                            height="600px"
                            title="PDF Viewer"
                            /> ||
                        <img src={previewUrl} alt="Uploaded Image" />
                    }
                </>
              }
            </Flex>
            </Modal>
            <Modal
             width={'70vw'}
            open={ShowImage}
            onCancel={()=>{
                setShowImage(false);
                setPreviewUrl(null);
            }}
            footer={<></>}
            >
                <h2>ข้อมูลเอกสาร</h2>
                <hr/>
                {previewUrl&&<Flex justify='center'>
                    <img src={previewUrl} alt="Uploaded Image" />
                </Flex>}
                <br/>
                <Flex justify='center'>
                    <Button type="primary" icon={<UploadOutlined />} onClick={() => {
                        window.open(previewUrl||'', '_blank');
                        }}>
                        ดาวน์โหลด
                    </Button>&nbsp;</Flex>
            </Modal>
          <br/>
          {AllData?.project_status=='รอตรวจสอบจากประธานจริยธรรม'&&<Card>
              <h3>ฟอร์มยื่นคำขอต่อกรรมการ</h3>
              <Form form={form}
                initialValues={{
                    ReviewDeadline: dayjs(),    
                }}>
                <Form.Item name='reviewType' label='รูปแบบการพิจารณา'>
                  <Radio.Group
                    onChange={(e)=>{
                        if(e.target.value=="การพิจารณาแบบยกเว้น (Exemption)"||
                            e.target.value=="การพิจารณาแบบเร่งรัด (Expedited Review)"){
                            setLimit(2);
                        }else{
                            setLimit(3);
                        }
                    }}
                    options={[
                      {value: 'การพิจารณาแบบยกเว้น (Exemption)', label: 'การพิจารณาแบบยกเว้น (Exemption)'},
                      { value: 'การพิจารณาแบบเร่งรัด (Expedited Review)', label: 'การพิจารณาแบบเร่งรัด (Expedited Review)' },
                      { value: 'การพิจารณาแบบเต็มชุด (Full Board Review)', label: 'การพิจารณาแบบเต็มชุด (Full Board Review)' },
                    ]}/>
                </Form.Item>
                <Card>
                <List
                    itemLayout="horizontal"
                    dataSource={SelectedCommittees}
                    renderItem={(item, index) => (
                        <List.Item
                        actions={[
                            <a key="delete" onClick={() => DeleteCommittee(item.CommitteeID)}>ลบ</a>
                        ]}
                        >
                        <List.Item.Meta
                            title={<span>{item.CommitteeName}</span>}
                        />
                        </List.Item>
                    )}
                    />
                    </Card>
                <br/>
                <Form.Item name='committeeName' label='กรุณาเลือกชื่อกรรมการ'>
                    <Select 
                    value={SelectedCommittee?.CommitteeID}
                    onChange={(value) => {
                        const tmp = Committees.filter(item => item.CommitteeID === value);
                        setSelectedCommittee(tmp[0]); // tmp will be an array with one item
                    }}
                    placeholder="กรุณาเลือกกรรมการที่ต้องการเพิ่ม"
                    options={Committees.map(item => ({
                        value: item.CommitteeID,
                        label: item.CommitteeName
                    }))}
                    />
                </Form.Item>
                <Flex justify='end'><Button onClick={addCommittee} disabled={limit==SelectedCommittees.length}>เพิ่มกรรมการ</Button></Flex>

                <hr/>
                <Form.Item name='ReviewDeadline' label='วันสิ้นสุดการอนุมัติ'>
                    <DatePicker
                    disabledDate={(current) => {
                        return current && current < dayjs().startOf('day');
                      }}/>
                </Form.Item>
                <Flex justify='center'>
                    <Button
                        onClick={()=>setConfirmationMod(true)}
                        variant="solid" 
                        color="cyan"
                        disabled={SelectedCommittees.length==0||limit==0}
                        // disabled={(limit!=SelectedCommittees.length||limit==0) || !isValidReviewDeadline}
                        >ยื่นโครงการให้กรรมการ</Button>
                    </Flex>
              </Form>
          </Card>}
          {(AllData?.project_status=='รอการพิจารณาจากกรรมการ'||
            AllData?.project_status=='รอการตรวจสอบผลพิจารณา'||
            AllData?.project_status=='รอพิจารณาผลการแก้ไขจากกรรมการ'
          )&&<>
            <br/>
            {
                AllData?.project_status=='รอพิจารณาผลการแก้ไขจากกรรมการ'&& <>
                    <Card>
                        <h3>ประวัติการพิจารณา</h3>
                        <Form.Item>
                        <Select
                            placeholder="กรุณาเลือกครั้งที่ต้องการตรวจสอบ"
                            onChange={(value) => {
                                const x = EXComment.filter((item) => item.EditNum === value);
                                console.log(x)
                                setshowEXComment(x);
                            }}
                            options={EXComment.filter(
                                (item, index, self) =>
                                index === self.findIndex((t) => t.EditNum === item.EditNum)
                            ).map((item) => ({
                                value: item.EditNum,
                                label: `ครั้งที่ ${item.EditNum} (${moment(item.last_review_at).format('DD/MM/YYYY')})`,
                            }))}
                            />
                        </Form.Item>
                        {showEXComment.length !== 0 && (
                            <><AnimatePresence>
                                <motion.div
                                    key="bloodCard"
                                    initial={{ opacity: 0, y: -20, scale: 0.9 }}
                                    animate={{ opacity: 1, y: 0, scale: 1 }}
                                    exit={{ opacity: 0, y: -20, scale: 0.9 }}
                                    transition={{ duration: 0.7, ease: [0.25, 0.8, 0.25, 1] }}
                                    >
                                {showEXComment.map((item, index) => (
                                    <div>
                                            <>
                                            <Card>
                                            <p>ชื่อกรรมการ : {item.CommitteeName}</p>
                                            {item.comment_status!=='Not submitted'&&
                                                <><p>สถานะการพิจารณา : {item.review_result||<span style={{color:'red'}}>ยังไม่อนุมัติ</span>}</p>
                                                {item.review_result=='รับรองในหลักการโดยมีข้อแก้ไข'&&<p>สัดส่วนการแก้ไข : {item.edit_overview}</p>}
                                                {item.review_result&&<><p>ข้อมูลการพิจารณา:</p>
                                                <Card style={{marginLeft:'5vw'}}>
                                                    <h3><u>เกณฑ์โครงการวิจัย</u></h3>
                                                    {AllData.review_type=='การพิจารณาแบบยกเว้น (Exemption)'&&<>
                                                        <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("1. เป็นกิจกรรมการเรียนการสอน การประกันคุณภาพการศึกษา การประกันคุณภาพ โรงพยาบาล การปรับปรุงคุณภาพงาน การประเมินผลการให้บริการของหน่วยงาน ทั้งนี้ต้องเป็นการดำเนินการตามแนวทางที่กำหนด") 
                                                        && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>} 1. เป็นกิจกรรมการเรียนการสอน การประกันคุณภาพการศึกษา การประกันคุณภาพ โรงพยาบาล การปรับปรุงคุณภาพงาน การประเมินผลการให้บริการของหน่วยงาน ทั้งนี้ต้องเป็นการดำเนินการตามแนวทางที่กำหนด</p>
                                                        <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("2. เป็นการวิจัยโดยใช้วิธีการสำรวจ สัมภาษณ์ ในประชากรที่เป็นผู้ใหญ่สุขภาพดี ทั้งนี้ต้อง") 
                                                        && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}2. เป็นการวิจัยโดยใช้วิธีการสำรวจ สัมภาษณ์ ในประชากรที่เป็นผู้ใหญ่สุขภาพดี ทั้งนี้ต้อง</p>
                                                        <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("2.1 ไม่มีหัวข้อ คำถามที่อ่อนไหว เช่น พฤติกรรมทางเพศ พฤติกรรมผิดกฎหมาย พฤติกรรมที่เสื่อมเสียชื่อเสียงต่อบุคคล/ชุมชน") 
                                                        && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}2.1 ไม่มีหัวข้อ คำถามที่อ่อนไหว เช่น พฤติกรรมทางเพศ พฤติกรรมผิดกฎหมาย พฤติกรรมที่เสื่อมเสียชื่อเสียงต่อบุคคล/ชุมชน</p>
                                                        <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("2.2 ไม่ถามทัศนคติที่หากเปิดเผยจะเป็นผลเสียแก่การจ้างงาน เช่น การสำรวจความพึง พอใจของข้าราชการเกี่ยวกับสวัสดิการที่ได้รับ") 
                                                        && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}2.2 ไม่ถามทัศนคติที่หากเปิดเผยจะเป็นผลเสียแก่การจ้างงาน เช่น การสำรวจความพึง พอใจของข้าราชการเกี่ยวกับสวัสดิการที่ได้รับ</p>
                                                        <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("2.3 ผลการสำรวจไม่ทำให้องค์กรที่ให้ข้อมูลเสื่อมเสียชื่อเสียง") 
                                                        && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}2.3 ผลการสำรวจไม่ทำให้องค์กรที่ให้ข้อมูลเสื่อมเสียชื่อเสียง</p>
                                                        <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("3. เป็นการวิจัยโดยการสังเกตพฤติกรรมของประชาชนในที่สาธารณะโดยที่") 
                                                        && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}3. เป็นการวิจัยโดยการสังเกตพฤติกรรมของประชาชนในที่สาธารณะโดยที่</p>
                                                        <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("3.1 ผู้วิจัยไม่ไปแทรกแซงหรือจัดฉาก") 
                                                        && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}3.1 ผู้วิจัยไม่ไปแทรกแซงหรือจัดฉาก </p>
                                                        <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("}3.2 พฤติกรรมที่ถูกสังเกต/สถานที่ที่ใช้สังเกตไม่ล่วงล้ำความเป็นส่วนตัว") 
                                                        && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}3.2 พฤติกรรมที่ถูกสังเกต/สถานที่ที่ใช้สังเกตไม่ล่วงล้ำความเป็นส่วนตัว</p>
                                                        <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("3.3 ไม่บันทึกข้อมูลในลักษณะที่บ่งบอกถึงตัวบุคคลได้") 
                                                        && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}3.3 ไม่บันทึกข้อมูลในลักษณะที่บ่งบอกถึงตัวบุคคลได้</p>
                                                        <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("4. เป็นรายงานผู้ป่วย (Case Report) ที่ผู้เสนอขอยกเว้นได้แสดงการปกป้องความลับของผู้ป่วยอย่าง เหมาะสม (หมายเหตุ ผู้วิจัยพึงตระหนักว่าวารสารวิชาการหลายแห่งอาจกำหนดให้มีหลักฐานหนังสือความยินยอมขอใช้ข้อมูลผู้ป่วย หรือภาพผู้ป่วย แล้วแต่กรณี)") 
                                                        && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}4. เป็นรายงานผู้ป่วย (Case Report) ที่ผู้เสนอขอยกเว้นได้แสดงการปกป้องความลับของผู้ป่วยอย่าง เหมาะสม (หมายเหตุ ผู้วิจัยพึงตระหนักว่าวารสารวิชาการหลายแห่งอาจกำหนดให้มีหลักฐานหนังสือความยินยอมขอใช้ข้อมูลผู้ป่วย หรือภาพผู้ป่วย แล้วแต่กรณี)  </p>
                                                        <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("5. เป็นการวิจัยโดยทดสอบรสชาติอาหาร คุณภาพของอาหาร และความพึงพอใจของผู้บริโภคใน ภาพรวม โดยอาหารที่นำมาทดสอบต้องปลอดภัย และได้มาตรฐานตามข้อกำหนดของสำนักงานคณะกรรมการ อาหารและยา (อย.) ทั้งนี้ ขึ้นอยู่กับดุลยพินิจของประธานฯ หรือผู้ที่ได้รับมอบหมาย") 
                                                        && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}5. เป็นการวิจัยโดยทดสอบรสชาติอาหาร คุณภาพของอาหาร และความพึงพอใจของผู้บริโภคใน ภาพรวม โดยอาหารที่นำมาทดสอบต้องปลอดภัย และได้มาตรฐานตามข้อกำหนดของสำนักงานคณะกรรมการ อาหารและยา (อย.) ทั้งนี้ ขึ้นอยู่กับดุลยพินิจของประธานฯ หรือผู้ที่ได้รับมอบหมาย  </p>
                                                    </>}
                                                    {AllData.review_type=='การพิจารณาแบบเร่งรัด (Expedited Review)'&&<>
                                                        <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                                                        && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1. ส่วนแก้ไขเพิ่มเติมโครงการวิจัยที่เป็นการแก้ไขเพิ่มเติมเล็กน้อยของโครงการวิจัยที่อนุมัติไปแล้วที่เป็นผลให้ความเสี่ยงของผู้ร่วมการวิจัยเพิ่มไม่เกินความเสี่ยงต่ำหรือไม่ทำให้การประเมินความเสี่ยงต่อผลประโยชน์เปลี่ยนไปอย่างมีนัยสำคัญ (Non-significant Risk) เช่น การแก้ไขคำผิด การแก้ไขรูปแบบการเขียนที่ ยังคงความหมายเดิม หรือการเปลี่ยนผู้วิจัยหรือที่อยู่ที่ติดต่อ </p>
                                                        <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                                                        && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}2. โครงการวิจัยที่มีการสัมภาษณ์ ใช้แบบสอบถามและไม่เป็นข้อมูลลับ หรือข้อมูลที่อ่อนไหว และไม่ก่อผลเสียหายต่อสถานภาพ หรือสิทธิประโยชน์ของบุคคล และไม่ก้าวล่วงความอ่อนไหวของประชากรที่เกี่ยวข้อง</p>
                                                        <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                                                        && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}3. การเก็บรวบรวมข้อมูล โดยมีวัตถุประสงค์เพื่อการวิจัยโดยกระบวนการที่ไม่รุกล้ำความเป็นส่วนตัวของบุคคลหรือกลุ่มบุคคล</p>
                                                        <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                                                        && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}4. การวิจัยเกี่ยวกับการใช้ข้อมูล (Data) บันทึก (Records) เอกสาร (Documents) ที่เก็บรวบรวมไว้แล้วโดยไม่เชื่อมโยงไปถึงตัวบุคคล</p>
                                                        <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                                                        && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}5. การวิจัยเกี่ยวกับพฤติกรรมที่เกี่ยวข้องกับลักษณะบุคคล กลุ่มบุคคล หรือการวิจัยที่ใช้วิธีการ สำรวจ สัมภาษณ์ ซักประวัติ การสนทนากลุ่ม (Focus Group) การประเมินโปรแกรมหรือวิธีการเกี่ยวกับการ ประกันคุณภาพ (Quality Assurance)  </p>
                                                    </>}
                                                    {AllData.review_type=='การพิจารณาแบบเต็มชุด (Full Board Review)'&&<>
                                                        <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("1.การวิจัยที่เกี่ยวข้องกับประชากรกลุ่มเปราะบาง (Vulnerable Group) ได้แก่") 
                                                        && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.การวิจัยที่เกี่ยวข้องกับประชากรกลุ่มเปราะบาง (Vulnerable Group) ได้แก่</p>
                                                        <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                                                        && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้</p>
                                                        <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("1.2 การวิจัยในผู้ป่วยที่ไม่สามารถรักษาหายได้") 
                                                        && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.2 การวิจัยในผู้ป่วยที่ไม่สามารถรักษาหายได้</p>
                                                        <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("1.3 การวิจัยในผู้ป่วยด้วยโรคที่สังคมไม่ยอมรับ เช่น โรคเอดส์ เป็นต้น") 
                                                        && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.3 การวิจัยในผู้ป่วยด้วยโรคที่สังคมไม่ยอมรับ เช่น โรคเอดส์ เป็นต้น</p>
                                                        <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("1.4 การวิจัยในผู้ที่มีความบกพร่องในการตัดสินใจ เช่น ผู้ที่มีความบกพร่องทางจิต ความทรงจำ หรือความผิดปกติด้านพฤติกรรม") 
                                                        && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.4 การวิจัยในผู้ที่มีความบกพร่องในการตัดสินใจ เช่น ผู้ที่มีความบกพร่องทางจิต ความทรงจำ หรือความผิดปกติด้านพฤติกรรม</p>
                                                        <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("1.5 การวิจัยในเด็กที่อยู่ในสถานพินิจ/สถานสงเคราะห์") 
                                                        && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.5 การวิจัยในเด็กที่อยู่ในสถานพินิจ/สถานสงเคราะห์</p>
                                                        <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                                                        && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.6 การวิจัยในกลุ่มผู้สูงอายุที่อยู่ในสถานสงเคราะห์</p>
                                                        <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                                                        && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.7 การวิจัยในทารกในครรภ์/หญิงตั้งครรภ์</p>
                                                        <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                                                        && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.8 การวิจัยในกลุ่มผู้ลี้ภัย</p>
                                                        <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                                                        && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.9 การวิจัยในนักโทษหรือผู้ต้องขัง</p>
                                                        <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                                                        && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.10 การวิจัยในกลุ่มคนไร้ที่อยู่</p>
                                                        <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                                                        && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.11 การวิจัยในชนกลุ่มน้อย หรือผู้ที่ไม่สามารถสื่อสารด้วยภาษาไทยได้</p>
                                                        <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                                                        && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.12 การวิจัยในกลุ่มผู้ขายบริการทางเพศ</p>
                                                        <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                                                        && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.13 การวิจัยในผู้เสพหรือผู้ขายสารเสพติด</p>
                                                        <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                                                        && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}2. การเปิดเผยตัวของผู้ร่วมการวิจัยก่อให้เกิดความเสี่ยงต่อการรับโทษทางแพ่ง หรือทางอาญา หรือเป็นผลเสียต่อสถานะทางการเงิน การจ้างงาน การประกัน หรืออาชีพ หรือถูกตีตรา เว้นแต่ โครงการวิจัยได้แสดงมาตรการปกป้องการรุกล้ำความเป็นส่วนตัว และความลับไม่ให้รั่วไหลอย่างเหมาะสมจนความเสี่ยงเหลือไม่เกินความเสี่ยงต่ำ</p>
                                                        <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                                                        && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}3. โครงการวิจัยที่ได้รับการพิจารณาให้การรับรองแล้ว และผู้วิจัยต้องการยื่นส่วนแก้ไขเปลี่ยนแปลง (Amendment) ซึ่งส่วนแก้ไขเพิ่มเติมนั้นมีผลกระทบเปลี่ยนแปลงความเสี่ยงของผู้ร่วมการวิจัยที่เพิ่มขึ้นมากกว่าเกณฑ์การประเมินโครงการวิจัยแบบเร่งรัด ต้องนำเข้าพิจารณาแบบเต็มชุด </p>
                                                        <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                                                        && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>} 4. โครงการวิจัยที่ได้รับการรับรองแล้วและผู้วิจัยต้องการรายงานความก้าวหน้าของโครงการ (Progress Report) แต่มีการดำเนินการที่เบี่ยงเบนไม่ปฏิบัติตามหรือฝ่าฝืนโครงการวิจัยต้องนำเข้า พิจารณาแบบเต็มชุด</p>
                                                    </>}
                                                    <Table columns={[
                                                        {
                                                            title:'ประเด็นพิจารณา',
                                                            dataIndex:'Topic',
                                                            width:'15vw'
                                                        },{
                                                            title:'ข้อเสนอแนะ',
                                                            dataIndex:'Reccommendation',
                                                            render:(_,record,index)=>(
                                                                <p
                                                                    style={{ fontSize: '16px', marginLeft: 20 }}
                                                                    dangerouslySetInnerHTML={{ 
                                                                        __html: (record?.Reccommendation || 'ไม่ได้ระบุ').replace(/\n/g, '<br/>') 
                                                                    }}
                                                                    />
                                                            )
                                                        }
                                                    ]} 
                                                    pagination={false} 
                                                    dataSource={JSON.parse(item.consideration_issues) as Issue[]}/>
                                                    <br/>
                                                    <Card>
                                                        <p>ข้อเสนอแนะเพิ่มเติม : {item.suggestion}</p>
                                                    </Card>
                                                </Card></>}</>||
                                                <><Card>
                                                    <p style={{color:'red'}}>สถานะการพิจารณา : ยังไม่ลงผลการพิจารณา</p> 
                                                    {item.read_status=='read'&&
                                                    <>
                                                        <p >สถานะการอ่าน : ตรวจสอบโครงการแล้ว</p> 
                                                    </>||
                                                    <p style={{color:'red'}}>สถานะการอ่าน : ยังไม่ตรวจสอบโครงการ</p> }   
                                                </Card></>}
                                            </Card>
                                            <br/></>
                                    </div>
                                ))}
                                </motion.div>
                            </AnimatePresence>
                            </>
                            )}
                    </Card>
                    <br/>
               </>
            }
            <Card>
                <Card>
                    <h3>ข้อมูลการพิจารณา</h3>
                    <p><span>ประเภทของการพิจารณา : {AllData.review_type}</span></p>
                </Card>
                <h3>รายชื่อกรรมการ</h3>
                <hr/>
                {Comment.map((item)=>(
                    <>
                    <Card>
                    <p>ชื่อกรรมการ : {item.CommitteeName}</p>
                    {item.comment_status!=='Not submitted'&&
                        <><p>สถานะการพิจารณา : {item.review_result||<span style={{color:'red'}}>ยังไม่อนุมัติ</span>}</p>
                        {item.review_result=='รับรองในหลักการโดยมีข้อแก้ไข'&&<p>สัดส่วนการแก้ไข : {item.edit_overview}</p>}
                        {item.review_result&&<><p>ข้อมูลการพิจารณา:</p>
                        <Card style={{marginLeft:'5vw'}}>
                            <h3><u>เกณฑ์โครงการวิจัย</u></h3>
                            {AllData.review_type=='การพิจารณาแบบยกเว้น (Exemption)'&&<>
                                <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("1. เป็นกิจกรรมการเรียนการสอน การประกันคุณภาพการศึกษา การประกันคุณภาพ โรงพยาบาล การปรับปรุงคุณภาพงาน การประเมินผลการให้บริการของหน่วยงาน ทั้งนี้ต้องเป็นการดำเนินการตามแนวทางที่กำหนด") 
                                && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>} 1. เป็นกิจกรรมการเรียนการสอน การประกันคุณภาพการศึกษา การประกันคุณภาพ โรงพยาบาล การปรับปรุงคุณภาพงาน การประเมินผลการให้บริการของหน่วยงาน ทั้งนี้ต้องเป็นการดำเนินการตามแนวทางที่กำหนด</p>
                                <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("2. เป็นการวิจัยโดยใช้วิธีการสำรวจ สัมภาษณ์ ในประชากรที่เป็นผู้ใหญ่สุขภาพดี ทั้งนี้ต้อง") 
                                && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}2. เป็นการวิจัยโดยใช้วิธีการสำรวจ สัมภาษณ์ ในประชากรที่เป็นผู้ใหญ่สุขภาพดี ทั้งนี้ต้อง</p>
                                <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("2.1 ไม่มีหัวข้อ คำถามที่อ่อนไหว เช่น พฤติกรรมทางเพศ พฤติกรรมผิดกฎหมาย พฤติกรรมที่เสื่อมเสียชื่อเสียงต่อบุคคล/ชุมชน") 
                                && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}2.1 ไม่มีหัวข้อ คำถามที่อ่อนไหว เช่น พฤติกรรมทางเพศ พฤติกรรมผิดกฎหมาย พฤติกรรมที่เสื่อมเสียชื่อเสียงต่อบุคคล/ชุมชน</p>
                                <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("2.2 ไม่ถามทัศนคติที่หากเปิดเผยจะเป็นผลเสียแก่การจ้างงาน เช่น การสำรวจความพึง พอใจของข้าราชการเกี่ยวกับสวัสดิการที่ได้รับ") 
                                && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}2.2 ไม่ถามทัศนคติที่หากเปิดเผยจะเป็นผลเสียแก่การจ้างงาน เช่น การสำรวจความพึง พอใจของข้าราชการเกี่ยวกับสวัสดิการที่ได้รับ</p>
                                <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("2.3 ผลการสำรวจไม่ทำให้องค์กรที่ให้ข้อมูลเสื่อมเสียชื่อเสียง") 
                                && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}2.3 ผลการสำรวจไม่ทำให้องค์กรที่ให้ข้อมูลเสื่อมเสียชื่อเสียง</p>
                                <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("3. เป็นการวิจัยโดยการสังเกตพฤติกรรมของประชาชนในที่สาธารณะโดยที่") 
                                && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}3. เป็นการวิจัยโดยการสังเกตพฤติกรรมของประชาชนในที่สาธารณะโดยที่</p>
                                <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("3.1 ผู้วิจัยไม่ไปแทรกแซงหรือจัดฉาก") 
                                && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}3.1 ผู้วิจัยไม่ไปแทรกแซงหรือจัดฉาก </p>
                                <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("}3.2 พฤติกรรมที่ถูกสังเกต/สถานที่ที่ใช้สังเกตไม่ล่วงล้ำความเป็นส่วนตัว") 
                                && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}3.2 พฤติกรรมที่ถูกสังเกต/สถานที่ที่ใช้สังเกตไม่ล่วงล้ำความเป็นส่วนตัว</p>
                                <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("3.3 ไม่บันทึกข้อมูลในลักษณะที่บ่งบอกถึงตัวบุคคลได้") 
                                && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}3.3 ไม่บันทึกข้อมูลในลักษณะที่บ่งบอกถึงตัวบุคคลได้</p>
                                <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("4. เป็นรายงานผู้ป่วย (Case Report) ที่ผู้เสนอขอยกเว้นได้แสดงการปกป้องความลับของผู้ป่วยอย่าง เหมาะสม (หมายเหตุ ผู้วิจัยพึงตระหนักว่าวารสารวิชาการหลายแห่งอาจกำหนดให้มีหลักฐานหนังสือความยินยอมขอใช้ข้อมูลผู้ป่วย หรือภาพผู้ป่วย แล้วแต่กรณี)") 
                                && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}4. เป็นรายงานผู้ป่วย (Case Report) ที่ผู้เสนอขอยกเว้นได้แสดงการปกป้องความลับของผู้ป่วยอย่าง เหมาะสม (หมายเหตุ ผู้วิจัยพึงตระหนักว่าวารสารวิชาการหลายแห่งอาจกำหนดให้มีหลักฐานหนังสือความยินยอมขอใช้ข้อมูลผู้ป่วย หรือภาพผู้ป่วย แล้วแต่กรณี)  </p>
                                <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("5. เป็นการวิจัยโดยทดสอบรสชาติอาหาร คุณภาพของอาหาร และความพึงพอใจของผู้บริโภคใน ภาพรวม โดยอาหารที่นำมาทดสอบต้องปลอดภัย และได้มาตรฐานตามข้อกำหนดของสำนักงานคณะกรรมการ อาหารและยา (อย.) ทั้งนี้ ขึ้นอยู่กับดุลยพินิจของประธานฯ หรือผู้ที่ได้รับมอบหมาย") 
                                && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}5. เป็นการวิจัยโดยทดสอบรสชาติอาหาร คุณภาพของอาหาร และความพึงพอใจของผู้บริโภคใน ภาพรวม โดยอาหารที่นำมาทดสอบต้องปลอดภัย และได้มาตรฐานตามข้อกำหนดของสำนักงานคณะกรรมการ อาหารและยา (อย.) ทั้งนี้ ขึ้นอยู่กับดุลยพินิจของประธานฯ หรือผู้ที่ได้รับมอบหมาย  </p>
                            </>}
                            {AllData.review_type=='การพิจารณาแบบเร่งรัด (Expedited Review)'&&<>
                                <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                                && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1. ส่วนแก้ไขเพิ่มเติมโครงการวิจัยที่เป็นการแก้ไขเพิ่มเติมเล็กน้อยของโครงการวิจัยที่อนุมัติไปแล้วที่เป็นผลให้ความเสี่ยงของผู้ร่วมการวิจัยเพิ่มไม่เกินความเสี่ยงต่ำหรือไม่ทำให้การประเมินความเสี่ยงต่อผลประโยชน์เปลี่ยนไปอย่างมีนัยสำคัญ (Non-significant Risk) เช่น การแก้ไขคำผิด การแก้ไขรูปแบบการเขียนที่ ยังคงความหมายเดิม หรือการเปลี่ยนผู้วิจัยหรือที่อยู่ที่ติดต่อ </p>
                                <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                                && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}2. โครงการวิจัยที่มีการสัมภาษณ์ ใช้แบบสอบถามและไม่เป็นข้อมูลลับ หรือข้อมูลที่อ่อนไหว และไม่ก่อผลเสียหายต่อสถานภาพ หรือสิทธิประโยชน์ของบุคคล และไม่ก้าวล่วงความอ่อนไหวของประชากรที่เกี่ยวข้อง</p>
                                <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                                && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}3. การเก็บรวบรวมข้อมูล โดยมีวัตถุประสงค์เพื่อการวิจัยโดยกระบวนการที่ไม่รุกล้ำความเป็นส่วนตัวของบุคคลหรือกลุ่มบุคคล</p>
                                <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                                && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}4. การวิจัยเกี่ยวกับการใช้ข้อมูล (Data) บันทึก (Records) เอกสาร (Documents) ที่เก็บรวบรวมไว้แล้วโดยไม่เชื่อมโยงไปถึงตัวบุคคล</p>
                                <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                                && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}5. การวิจัยเกี่ยวกับพฤติกรรมที่เกี่ยวข้องกับลักษณะบุคคล กลุ่มบุคคล หรือการวิจัยที่ใช้วิธีการ สำรวจ สัมภาษณ์ ซักประวัติ การสนทนากลุ่ม (Focus Group) การประเมินโปรแกรมหรือวิธีการเกี่ยวกับการ ประกันคุณภาพ (Quality Assurance)  </p>
                            </>}
                            {AllData.review_type=='การพิจารณาแบบเต็มชุด (Full Board Review)'&&<>
                                <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("1.การวิจัยที่เกี่ยวข้องกับประชากรกลุ่มเปราะบาง (Vulnerable Group) ได้แก่") 
                                && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.การวิจัยที่เกี่ยวข้องกับประชากรกลุ่มเปราะบาง (Vulnerable Group) ได้แก่</p>
                                <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                                && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้</p>
                                <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("1.2 การวิจัยในผู้ป่วยที่ไม่สามารถรักษาหายได้") 
                                && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.2 การวิจัยในผู้ป่วยที่ไม่สามารถรักษาหายได้</p>
                                <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("1.3 การวิจัยในผู้ป่วยด้วยโรคที่สังคมไม่ยอมรับ เช่น โรคเอดส์ เป็นต้น") 
                                && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.3 การวิจัยในผู้ป่วยด้วยโรคที่สังคมไม่ยอมรับ เช่น โรคเอดส์ เป็นต้น</p>
                                <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("1.4 การวิจัยในผู้ที่มีความบกพร่องในการตัดสินใจ เช่น ผู้ที่มีความบกพร่องทางจิต ความทรงจำ หรือความผิดปกติด้านพฤติกรรม") 
                                && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.4 การวิจัยในผู้ที่มีความบกพร่องในการตัดสินใจ เช่น ผู้ที่มีความบกพร่องทางจิต ความทรงจำ หรือความผิดปกติด้านพฤติกรรม</p>
                                <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("1.5 การวิจัยในเด็กที่อยู่ในสถานพินิจ/สถานสงเคราะห์") 
                                && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.5 การวิจัยในเด็กที่อยู่ในสถานพินิจ/สถานสงเคราะห์</p>
                                <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                                && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.6 การวิจัยในกลุ่มผู้สูงอายุที่อยู่ในสถานสงเคราะห์</p>
                                <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                                && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.7 การวิจัยในทารกในครรภ์/หญิงตั้งครรภ์</p>
                                <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                                && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.8 การวิจัยในกลุ่มผู้ลี้ภัย</p>
                                <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                                && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.9 การวิจัยในนักโทษหรือผู้ต้องขัง</p>
                                <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                                && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.10 การวิจัยในกลุ่มคนไร้ที่อยู่</p>
                                <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                                && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.11 การวิจัยในชนกลุ่มน้อย หรือผู้ที่ไม่สามารถสื่อสารด้วยภาษาไทยได้</p>
                                <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                                && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.12 การวิจัยในกลุ่มผู้ขายบริการทางเพศ</p>
                                <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                                && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.13 การวิจัยในผู้เสพหรือผู้ขายสารเสพติด</p>
                                <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                                && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}2. การเปิดเผยตัวของผู้ร่วมการวิจัยก่อให้เกิดความเสี่ยงต่อการรับโทษทางแพ่ง หรือทางอาญา หรือเป็นผลเสียต่อสถานะทางการเงิน การจ้างงาน การประกัน หรืออาชีพ หรือถูกตีตรา เว้นแต่ โครงการวิจัยได้แสดงมาตรการปกป้องการรุกล้ำความเป็นส่วนตัว และความลับไม่ให้รั่วไหลอย่างเหมาะสมจนความเสี่ยงเหลือไม่เกินความเสี่ยงต่ำ</p>
                                <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                                && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}3. โครงการวิจัยที่ได้รับการพิจารณาให้การรับรองแล้ว และผู้วิจัยต้องการยื่นส่วนแก้ไขเปลี่ยนแปลง (Amendment) ซึ่งส่วนแก้ไขเพิ่มเติมนั้นมีผลกระทบเปลี่ยนแปลงความเสี่ยงของผู้ร่วมการวิจัยที่เพิ่มขึ้นมากกว่าเกณฑ์การประเมินโครงการวิจัยแบบเร่งรัด ต้องนำเข้าพิจารณาแบบเต็มชุด </p>
                                <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                                && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>} 4. โครงการวิจัยที่ได้รับการรับรองแล้วและผู้วิจัยต้องการรายงานความก้าวหน้าของโครงการ (Progress Report) แต่มีการดำเนินการที่เบี่ยงเบนไม่ปฏิบัติตามหรือฝ่าฝืนโครงการวิจัยต้องนำเข้า พิจารณาแบบเต็มชุด</p>
                            </>}
                            <Table columns={[
                                {
                                    title:'ประเด็นพิจารณา',
                                    dataIndex:'Topic',
                                    width:'15vw'
                                },{
                                    title:'ข้อเสนอแนะ',
                                    dataIndex:'Reccommendation',
                                    render:(_,record,index)=>(
                                        <p
                                            style={{ fontSize: '16px', marginLeft: 20 }}
                                            dangerouslySetInnerHTML={{ 
                                                __html: (record?.Reccommendation || 'ไม่ได้ระบุ').replace(/\n/g, '<br/>') 
                                            }}
                                            />
                                    )
                                }
                            ]} 
                            pagination={false} 
                            dataSource={JSON.parse(item.consideration_issues) as Issue[]}/>
                            <br/>
                            <Card>
                                <p>ข้อเสนอแนะเพิ่มเติม : {item.suggestion}</p>
                            </Card>
                        </Card></>}</>||
                        <><Card>
                        <p >สถานะการพิจารณา : <span style={{color:'red'}}>ยังไม่ลงผลการพิจารณา</span> </p> 
                            {item.read_status=='read'&&
                            <>
                                <p>สถานะการอ่าน : ตรวจสอบโครงการแล้ว</p> 
                            </>||
                            <p>สถานะการอ่าน : <span style={{color:'red'}}>ยังไม่ตรวจสอบโครงการ</span></p> }   
                        </Card></>}
                    </Card>
                    <br/></>))}
               
                <br/>
            {<Flex justify='center'><Button onClick={()=>{setPullBackConfirmation(true)}}>ดึงข้อมูลกลับ</Button></Flex>}
            </Card>
            <Modal
                onCancel={()=>setPullBackConfirmation(false)}
                onOk={()=>{getProjectback();}
                }
                width={'50vw'}
                open={PullBackConfirmation}>
                <h1>ยืนยันการดึงข้อมูลกลับ</h1>
                <hr/>
                <p>คุณต้องการดึงข้อมูลกลับจากคณะกรรมการหรือไม่</p>
                <Card><p>หมายเหตุ: ท่านสามารถดึงข้อมูลกลับจากกรรมการเพื่อเปลี่ยนกรรมการได้ แต่ท่านไม่สามารถเปลี่ยนแปลงกรรมการที่ได้ลงผลพิจารณาได้</p></Card>
            </Modal>
          </>}
          {
            AllData?.project_status=='ประธานฯแต่งตั้งกรรมการใหม่'&&<>
            <Card>
                <h3>ผลการพิจารณาของกรรมการ</h3>
                <p>ประเภทของการพิจารณา : {AllData?.review_type}</p>
                {Comment.map((item)=>(
                    <>
                    <Card>
                    <p>ชื่อกรรมการ : {item.CommitteeName}</p>
                    <p>สถานะการพิจารณา : {item.review_result||<span style={{color:'red'}}>ยังไม่อนุมัติ</span>}</p>
                    {item.review_result&&<><p>ข้อมูลการพิจารณา:</p>
                    <Card style={{marginLeft:'5vw'}}>
                        <h3><u>เกณฑ์โครงการวิจัย</u></h3>
                        {AllData.review_type=='การพิจารณาแบบยกเว้น (Exemption)'&&<>
                            <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("1. เป็นกิจกรรมการเรียนการสอน การประกันคุณภาพการศึกษา การประกันคุณภาพ โรงพยาบาล การปรับปรุงคุณภาพงาน การประเมินผลการให้บริการของหน่วยงาน ทั้งนี้ต้องเป็นการดำเนินการตามแนวทางที่กำหนด") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>} 1. เป็นกิจกรรมการเรียนการสอน การประกันคุณภาพการศึกษา การประกันคุณภาพ โรงพยาบาล การปรับปรุงคุณภาพงาน การประเมินผลการให้บริการของหน่วยงาน ทั้งนี้ต้องเป็นการดำเนินการตามแนวทางที่กำหนด</p>
                            <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}2. เป็นการวิจัยโดยใช้วิธีการสำรวจ สัมภาษณ์ ในประชากรที่เป็นผู้ใหญ่สุขภาพดี ทั้งนี้ต้อง</p>
                            <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}2.1 ไม่มีหัวข้อ คำถามที่อ่อนไหว เช่น พฤติกรรมทางเพศ พฤติกรรมผิดกฎหมาย พฤติกรรมที่เสื่อมเสียชื่อเสียงต่อบุคคล/ชุมชน</p>
                            <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}2.2 ไม่ถามทัศนคติที่หากเปิดเผยจะเป็นผลเสียแก่การจ้างงาน เช่น การสำรวจความพึง พอใจของข้าราชการเกี่ยวกับสวัสดิการที่ได้รับ</p>
                            <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}2.3 ผลการสำรวจไม่ทำให้องค์กรที่ให้ข้อมูลเสื่อมเสียชื่อเสียง</p>
                            <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}3. เป็นการวิจัยโดยการสังเกตพฤติกรรมของประชาชนในที่สาธารณะโดยที่</p>
                            <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}3.1 ผู้วิจัยไม่ไปแทรกแซงหรือจัดฉาก </p>
                            <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}3.2 พฤติกรรมที่ถูกสังเกต/สถานที่ที่ใช้สังเกตไม่ล่วงล้ำความเป็นส่วนตัว</p>
                            <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}3.3 ไม่บันทึกข้อมูลในลักษณะที่บ่งบอกถึงตัวบุคคลได้</p>
                            <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}4. เป็นรายงานผู้ป่วย (Case Report) ที่ผู้เสนอขอยกเว้นได้แสดงการปกป้องความลับของผู้ป่วยอย่าง เหมาะสม (หมายเหตุ ผู้วิจัยพึงตระหนักว่าวารสารวิชาการหลายแห่งอาจกำหนดให้มีหลักฐานหนังสือความยินยอมขอใช้ข้อมูลผู้ป่วย หรือภาพผู้ป่วย แล้วแต่กรณี)  </p>
                            <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}5. เป็นการวิจัยโดยทดสอบรสชาติอาหาร คุณภาพของอาหาร และความพึงพอใจของผู้บริโภคใน ภาพรวม โดยอาหารที่นำมาทดสอบต้องปลอดภัย และได้มาตรฐานตามข้อกำหนดของสำนักงานคณะกรรมการ อาหารและยา (อย.) ทั้งนี้ ขึ้นอยู่กับดุลยพินิจของประธานฯ หรือผู้ที่ได้รับมอบหมาย  </p>
                        </>}
                        {AllData.review_type=='การพิจารณาแบบเร่งรัด (Expedited Review)'&&<>
                            <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1. ส่วนแก้ไขเพิ่มเติมโครงการวิจัยที่เป็นการแก้ไขเพิ่มเติมเล็กน้อยของโครงการวิจัยที่อนุมัติไปแล้วที่เป็นผลให้ความเสี่ยงของผู้ร่วมการวิจัยเพิ่มไม่เกินความเสี่ยงต่ำหรือไม่ทำให้การประเมินความเสี่ยงต่อผลประโยชน์เปลี่ยนไปอย่างมีนัยสำคัญ (Non-significant Risk) เช่น การแก้ไขคำผิด การแก้ไขรูปแบบการเขียนที่ ยังคงความหมายเดิม หรือการเปลี่ยนผู้วิจัยหรือที่อยู่ที่ติดต่อ </p>
                            <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}2. โครงการวิจัยที่มีการสัมภาษณ์ ใช้แบบสอบถามและไม่เป็นข้อมูลลับ หรือข้อมูลที่อ่อนไหว และไม่ก่อผลเสียหายต่อสถานภาพ หรือสิทธิประโยชน์ของบุคคล และไม่ก้าวล่วงความอ่อนไหวของประชากรที่เกี่ยวข้อง</p>
                            <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}3. การเก็บรวบรวมข้อมูล โดยมีวัตถุประสงค์เพื่อการวิจัยโดยกระบวนการที่ไม่รุกล้ำความเป็นส่วนตัวของบุคคลหรือกลุ่มบุคคล</p>
                            <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}4. การวิจัยเกี่ยวกับการใช้ข้อมูล (Data) บันทึก (Records) เอกสาร (Documents) ที่เก็บรวบรวมไว้แล้วโดยไม่เชื่อมโยงไปถึงตัวบุคคล</p>
                            <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}5. การวิจัยเกี่ยวกับพฤติกรรมที่เกี่ยวข้องกับลักษณะบุคคล กลุ่มบุคคล หรือการวิจัยที่ใช้วิธีการ สำรวจ สัมภาษณ์ ซักประวัติ การสนทนากลุ่ม (Focus Group) การประเมินโปรแกรมหรือวิธีการเกี่ยวกับการ ประกันคุณภาพ (Quality Assurance)  </p>
                        </>}
                        {AllData.review_type=='การพิจารณาแบบเต็มชุด (Full Board Review)'&&<>
                            <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("1.การวิจัยที่เกี่ยวข้องกับประชากรกลุ่มเปราะบาง (Vulnerable Group) ได้แก่") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.การวิจัยที่เกี่ยวข้องกับประชากรกลุ่มเปราะบาง (Vulnerable Group) ได้แก่</p>
                            <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้</p>
                            <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.2 การวิจัยในผู้ป่วยที่ไม่สามารถรักษาหายได้</p>
                            <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.3 การวิจัยในผู้ป่วยด้วยโรคที่สังคมไม่ยอมรับ เช่น โรคเอดส์ เป็นต้น</p>
                            <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.4 การวิจัยในผู้ที่มีความบกพร่องในการตัดสินใจ เช่น ผู้ที่มีความบกพร่องทางจิต ความทรงจำ หรือความผิดปกติด้านพฤติกรรม</p>
                            <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.5 การวิจัยในเด็กที่อยู่ในสถานพินิจ/สถานสงเคราะห์</p>
                            <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.6 การวิจัยในกลุ่มผู้สูงอายุที่อยู่ในสถานสงเคราะห์</p>
                            <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.7 การวิจัยในทารกในครรภ์/หญิงตั้งครรภ์</p>
                            <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.8 การวิจัยในกลุ่มผู้ลี้ภัย</p>
                            <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.9 การวิจัยในนักโทษหรือผู้ต้องขัง</p>
                            <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.10 การวิจัยในกลุ่มคนไร้ที่อยู่</p>
                            <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.11 การวิจัยในชนกลุ่มน้อย หรือผู้ที่ไม่สามารถสื่อสารด้วยภาษาไทยได้</p>
                            <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.12 การวิจัยในกลุ่มผู้ขายบริการทางเพศ</p>
                            <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.13 การวิจัยในผู้เสพหรือผู้ขายสารเสพติด</p>
                            <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}2. การเปิดเผยตัวของผู้ร่วมการวิจัยก่อให้เกิดความเสี่ยงต่อการรับโทษทางแพ่ง หรือทางอาญา หรือเป็นผลเสียต่อสถานะทางการเงิน การจ้างงาน การประกัน หรืออาชีพ หรือถูกตีตรา เว้นแต่ โครงการวิจัยได้แสดงมาตรการปกป้องการรุกล้ำความเป็นส่วนตัว และความลับไม่ให้รั่วไหลอย่างเหมาะสมจนความเสี่ยงเหลือไม่เกินความเสี่ยงต่ำ</p>
                            <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}3. โครงการวิจัยที่ได้รับการพิจารณาให้การรับรองแล้ว และผู้วิจัยต้องการยื่นส่วนแก้ไขเปลี่ยนแปลง (Amendment) ซึ่งส่วนแก้ไขเพิ่มเติมนั้นมีผลกระทบเปลี่ยนแปลงความเสี่ยงของผู้ร่วมการวิจัยที่เพิ่มขึ้นมากกว่าเกณฑ์การประเมินโครงการวิจัยแบบเร่งรัด ต้องนำเข้าพิจารณาแบบเต็มชุด </p>
                            <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>} 4. โครงการวิจัยที่ได้รับการรับรองแล้วและผู้วิจัยต้องการรายงานความก้าวหน้าของโครงการ (Progress Report) แต่มีการดำเนินการที่เบี่ยงเบนไม่ปฏิบัติตามหรือฝ่าฝืนโครงการวิจัยต้องนำเข้า พิจารณาแบบเต็มชุด</p>
                        </>}
                        <Table columns={[
                            {
                                title:'ประเด็นพิจารณา',
                                dataIndex:'Topic'
                            },{
                                title:'ข้อเสนอแนะ',
                                dataIndex:'Reccommendation',
                                render:(_,record,index)=>(
                                    <p
                                        style={{ fontSize: '16px', marginLeft: 20 }}
                                        dangerouslySetInnerHTML={{ 
                                            __html: (record?.Reccommendation || 'ไม่ได้ระบุ').replace(/\n/g, '<br/>') 
                                        }}
                                        />
                                )
                            }
                        ]}
                        dataSource={JSON.parse(item.consideration_issues) as Issue[]}/>
                        <p>ข้อเสนอแนะเพิ่มเติม : {item.suggestion|| ''}</p>
                    </Card></>}
                    </Card>
                    <br/></>))}
                    
                <h3>รายชื่อกรรมการ</h3>
                <Form form={form}
                    initialValues={{
                        ReviewDeadline: dayjs(),    
                    }}>
                    <Card>
                    <List
                        itemLayout="horizontal"
                        dataSource={SelectedCommittees||[]}
                        renderItem={(item, index) => (
                            <List.Item
                            actions={[
                                <a key="delete" onClick={() => DeleteCommittee(item.CommitteeID)}
                                style={{
                                    color: Comment[index].comment_status!='Not submitted' ? 'gray' : 'blue',
                                    pointerEvents: Comment[index].comment_status!='Not submitted' ? 'none' : 'auto',
                                    cursor: Comment[index].comment_status!='Not submitted' ? 'not-allowed' : 'pointer',
                                  }}
                                >ลบ</a>
                            ]}
                            >
                            <List.Item.Meta
                                title={<span>{item.CommitteeName}</span>}
                                description={<p>{Comment[index].comment_status=='Not submitted'&&<span>ยังไม่ส่งผลพิจารณา</span>||<span>ส่งผลพิจารณาแล้ว</span>}</p>}
                            />
                            </List.Item>
                        )}
                        />
                    </Card>
                    <br/>
                    <Form.Item name='committeeName' label='กรุณาเลือกชื่อกรรมการ'>
                        <Select 
                            value={SelectedCommittee?.CommitteeID}
                            onChange={(value) => {
                                const tmp = Committees.filter(item => item.CommitteeID === value);
                                setSelectedCommittee(tmp[0]); // tmp will be an array with one item
                            }}
                            placeholder="กรุณาเลือกกรรมการที่ต้องการเพิ่ม"
                            options={Committees.map(item => ({
                                value: item.CommitteeID,
                                label: item.CommitteeName
                            }))}
                            disabled={limit==SelectedCommittees.length}
                        />
                    </Form.Item>
                    <Flex justify='end'><Button onClick={addCommittee} disabled={limit==SelectedCommittees.length}>เพิ่มกรรมการ</Button></Flex>
                    <Form.Item name='ReviewDeadline' label='วันสิ้นสุดการอนุมัติ'>
                        <DatePicker
                        disabledDate={(current) => {
                            return current && current < dayjs().startOf('day');
                        }}/>
                    </Form.Item> 
                    <Flex justify='center'>
                    <Button
                        onClick={()=>setConfirmationMod(true)}
                        variant="solid" 
                        color="cyan"
                        // disabled={(limit!=SelectedCommittees.length||limit==0) || !isValidReviewDeadline}
                        >ยื่นโครงการให้กรรมการ</Button>
                    </Flex>
                </Form>
            </Card>
            </>
          }

          {
             AllData?.project_status=='รอตรวจสอบผลการแก้ไขจากประธาน'&&<>
                <Card>
                    <h2>ผลการพิจารณาของกรรมการ</h2>
                    {Comment.map((item)=>(
                    <>
                    <Card>
                    <p>ชื่อกรรมการ : {item.CommitteeName}</p>
                    <p>สถานะการพิจารณา : {item.review_result||<span style={{color:'red'}}>ยังไม่อนุมัติ</span>}</p>
                    {item.review_result=='รับรองในหลักการโดยมีข้อแก้ไข'&&<p>สัดส่วนการแก้ไข : {item.edit_overview}</p>}
                    {item.review_result&&<><p>ข้อมูลการพิจารณา:</p>
                    <Card style={{marginLeft:'5vw'}}>
                        <h3><u>เกณฑ์โครงการวิจัย</u></h3>
                        {AllData.review_type=='การพิจารณาแบบยกเว้น (Exemption)'&&<>
                            <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("1. เป็นกิจกรรมการเรียนการสอน การประกันคุณภาพการศึกษา การประกันคุณภาพ โรงพยาบาล การปรับปรุงคุณภาพงาน การประเมินผลการให้บริการของหน่วยงาน ทั้งนี้ต้องเป็นการดำเนินการตามแนวทางที่กำหนด") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>} 1. เป็นกิจกรรมการเรียนการสอน การประกันคุณภาพการศึกษา การประกันคุณภาพ โรงพยาบาล การปรับปรุงคุณภาพงาน การประเมินผลการให้บริการของหน่วยงาน ทั้งนี้ต้องเป็นการดำเนินการตามแนวทางที่กำหนด</p>
                            <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("2. เป็นการวิจัยโดยใช้วิธีการสำรวจ สัมภาษณ์ ในประชากรที่เป็นผู้ใหญ่สุขภาพดี ทั้งนี้ต้อง") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}2. เป็นการวิจัยโดยใช้วิธีการสำรวจ สัมภาษณ์ ในประชากรที่เป็นผู้ใหญ่สุขภาพดี ทั้งนี้ต้อง</p>
                            <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("2.1 ไม่มีหัวข้อ คำถามที่อ่อนไหว เช่น พฤติกรรมทางเพศ พฤติกรรมผิดกฎหมาย พฤติกรรมที่เสื่อมเสียชื่อเสียงต่อบุคคล/ชุมชน") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}2.1 ไม่มีหัวข้อ คำถามที่อ่อนไหว เช่น พฤติกรรมทางเพศ พฤติกรรมผิดกฎหมาย พฤติกรรมที่เสื่อมเสียชื่อเสียงต่อบุคคล/ชุมชน</p>
                            <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("2.2 ไม่ถามทัศนคติที่หากเปิดเผยจะเป็นผลเสียแก่การจ้างงาน เช่น การสำรวจความพึง พอใจของข้าราชการเกี่ยวกับสวัสดิการที่ได้รับ") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}2.2 ไม่ถามทัศนคติที่หากเปิดเผยจะเป็นผลเสียแก่การจ้างงาน เช่น การสำรวจความพึง พอใจของข้าราชการเกี่ยวกับสวัสดิการที่ได้รับ</p>
                            <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("2.3 ผลการสำรวจไม่ทำให้องค์กรที่ให้ข้อมูลเสื่อมเสียชื่อเสียง") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}2.3 ผลการสำรวจไม่ทำให้องค์กรที่ให้ข้อมูลเสื่อมเสียชื่อเสียง</p>
                            <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("3. เป็นการวิจัยโดยการสังเกตพฤติกรรมของประชาชนในที่สาธารณะโดยที่") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}3. เป็นการวิจัยโดยการสังเกตพฤติกรรมของประชาชนในที่สาธารณะโดยที่</p>
                            <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("3.1 ผู้วิจัยไม่ไปแทรกแซงหรือจัดฉาก") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}3.1 ผู้วิจัยไม่ไปแทรกแซงหรือจัดฉาก </p>
                            <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("}3.2 พฤติกรรมที่ถูกสังเกต/สถานที่ที่ใช้สังเกตไม่ล่วงล้ำความเป็นส่วนตัว") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}3.2 พฤติกรรมที่ถูกสังเกต/สถานที่ที่ใช้สังเกตไม่ล่วงล้ำความเป็นส่วนตัว</p>
                            <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("3.3 ไม่บันทึกข้อมูลในลักษณะที่บ่งบอกถึงตัวบุคคลได้") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}3.3 ไม่บันทึกข้อมูลในลักษณะที่บ่งบอกถึงตัวบุคคลได้</p>
                            <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("4. เป็นรายงานผู้ป่วย (Case Report) ที่ผู้เสนอขอยกเว้นได้แสดงการปกป้องความลับของผู้ป่วยอย่าง เหมาะสม (หมายเหตุ ผู้วิจัยพึงตระหนักว่าวารสารวิชาการหลายแห่งอาจกำหนดให้มีหลักฐานหนังสือความยินยอมขอใช้ข้อมูลผู้ป่วย หรือภาพผู้ป่วย แล้วแต่กรณี)") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}4. เป็นรายงานผู้ป่วย (Case Report) ที่ผู้เสนอขอยกเว้นได้แสดงการปกป้องความลับของผู้ป่วยอย่าง เหมาะสม (หมายเหตุ ผู้วิจัยพึงตระหนักว่าวารสารวิชาการหลายแห่งอาจกำหนดให้มีหลักฐานหนังสือความยินยอมขอใช้ข้อมูลผู้ป่วย หรือภาพผู้ป่วย แล้วแต่กรณี)  </p>
                            <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("5. เป็นการวิจัยโดยทดสอบรสชาติอาหาร คุณภาพของอาหาร และความพึงพอใจของผู้บริโภคใน ภาพรวม โดยอาหารที่นำมาทดสอบต้องปลอดภัย และได้มาตรฐานตามข้อกำหนดของสำนักงานคณะกรรมการ อาหารและยา (อย.) ทั้งนี้ ขึ้นอยู่กับดุลยพินิจของประธานฯ หรือผู้ที่ได้รับมอบหมาย") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}5. เป็นการวิจัยโดยทดสอบรสชาติอาหาร คุณภาพของอาหาร และความพึงพอใจของผู้บริโภคใน ภาพรวม โดยอาหารที่นำมาทดสอบต้องปลอดภัย และได้มาตรฐานตามข้อกำหนดของสำนักงานคณะกรรมการ อาหารและยา (อย.) ทั้งนี้ ขึ้นอยู่กับดุลยพินิจของประธานฯ หรือผู้ที่ได้รับมอบหมาย  </p>
                        </>}
                        {AllData.review_type=='การพิจารณาแบบเร่งรัด (Expedited Review)'&&<>
                            <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1. ส่วนแก้ไขเพิ่มเติมโครงการวิจัยที่เป็นการแก้ไขเพิ่มเติมเล็กน้อยของโครงการวิจัยที่อนุมัติไปแล้วที่เป็นผลให้ความเสี่ยงของผู้ร่วมการวิจัยเพิ่มไม่เกินความเสี่ยงต่ำหรือไม่ทำให้การประเมินความเสี่ยงต่อผลประโยชน์เปลี่ยนไปอย่างมีนัยสำคัญ (Non-significant Risk) เช่น การแก้ไขคำผิด การแก้ไขรูปแบบการเขียนที่ ยังคงความหมายเดิม หรือการเปลี่ยนผู้วิจัยหรือที่อยู่ที่ติดต่อ </p>
                            <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}2. โครงการวิจัยที่มีการสัมภาษณ์ ใช้แบบสอบถามและไม่เป็นข้อมูลลับ หรือข้อมูลที่อ่อนไหว และไม่ก่อผลเสียหายต่อสถานภาพ หรือสิทธิประโยชน์ของบุคคล และไม่ก้าวล่วงความอ่อนไหวของประชากรที่เกี่ยวข้อง</p>
                            <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}3. การเก็บรวบรวมข้อมูล โดยมีวัตถุประสงค์เพื่อการวิจัยโดยกระบวนการที่ไม่รุกล้ำความเป็นส่วนตัวของบุคคลหรือกลุ่มบุคคล</p>
                            <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}4. การวิจัยเกี่ยวกับการใช้ข้อมูล (Data) บันทึก (Records) เอกสาร (Documents) ที่เก็บรวบรวมไว้แล้วโดยไม่เชื่อมโยงไปถึงตัวบุคคล</p>
                            <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}5. การวิจัยเกี่ยวกับพฤติกรรมที่เกี่ยวข้องกับลักษณะบุคคล กลุ่มบุคคล หรือการวิจัยที่ใช้วิธีการ สำรวจ สัมภาษณ์ ซักประวัติ การสนทนากลุ่ม (Focus Group) การประเมินโปรแกรมหรือวิธีการเกี่ยวกับการ ประกันคุณภาพ (Quality Assurance)  </p>
                        </>}
                        {AllData.review_type=='การพิจารณาแบบเต็มชุด (Full Board Review)'&&<>
                            <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("1.การวิจัยที่เกี่ยวข้องกับประชากรกลุ่มเปราะบาง (Vulnerable Group) ได้แก่") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.การวิจัยที่เกี่ยวข้องกับประชากรกลุ่มเปราะบาง (Vulnerable Group) ได้แก่</p>
                            <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้</p>
                            <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("1.2 การวิจัยในผู้ป่วยที่ไม่สามารถรักษาหายได้") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.2 การวิจัยในผู้ป่วยที่ไม่สามารถรักษาหายได้</p>
                            <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("1.3 การวิจัยในผู้ป่วยด้วยโรคที่สังคมไม่ยอมรับ เช่น โรคเอดส์ เป็นต้น") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.3 การวิจัยในผู้ป่วยด้วยโรคที่สังคมไม่ยอมรับ เช่น โรคเอดส์ เป็นต้น</p>
                            <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("1.4 การวิจัยในผู้ที่มีความบกพร่องในการตัดสินใจ เช่น ผู้ที่มีความบกพร่องทางจิต ความทรงจำ หรือความผิดปกติด้านพฤติกรรม") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.4 การวิจัยในผู้ที่มีความบกพร่องในการตัดสินใจ เช่น ผู้ที่มีความบกพร่องทางจิต ความทรงจำ หรือความผิดปกติด้านพฤติกรรม</p>
                            <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("1.5 การวิจัยในเด็กที่อยู่ในสถานพินิจ/สถานสงเคราะห์") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.5 การวิจัยในเด็กที่อยู่ในสถานพินิจ/สถานสงเคราะห์</p>
                            <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.6 การวิจัยในกลุ่มผู้สูงอายุที่อยู่ในสถานสงเคราะห์</p>
                            <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.7 การวิจัยในทารกในครรภ์/หญิงตั้งครรภ์</p>
                            <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.8 การวิจัยในกลุ่มผู้ลี้ภัย</p>
                            <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.9 การวิจัยในนักโทษหรือผู้ต้องขัง</p>
                            <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.10 การวิจัยในกลุ่มคนไร้ที่อยู่</p>
                            <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.11 การวิจัยในชนกลุ่มน้อย หรือผู้ที่ไม่สามารถสื่อสารด้วยภาษาไทยได้</p>
                            <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.12 การวิจัยในกลุ่มผู้ขายบริการทางเพศ</p>
                            <p style={{marginLeft:'10vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}1.13 การวิจัยในผู้เสพหรือผู้ขายสารเสพติด</p>
                            <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}2. การเปิดเผยตัวของผู้ร่วมการวิจัยก่อให้เกิดความเสี่ยงต่อการรับโทษทางแพ่ง หรือทางอาญา หรือเป็นผลเสียต่อสถานะทางการเงิน การจ้างงาน การประกัน หรืออาชีพ หรือถูกตีตรา เว้นแต่ โครงการวิจัยได้แสดงมาตรการปกป้องการรุกล้ำความเป็นส่วนตัว และความลับไม่ให้รั่วไหลอย่างเหมาะสมจนความเสี่ยงเหลือไม่เกินความเสี่ยงต่ำ</p>
                            <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>}3. โครงการวิจัยที่ได้รับการพิจารณาให้การรับรองแล้ว และผู้วิจัยต้องการยื่นส่วนแก้ไขเปลี่ยนแปลง (Amendment) ซึ่งส่วนแก้ไขเพิ่มเติมนั้นมีผลกระทบเปลี่ยนแปลงความเสี่ยงของผู้ร่วมการวิจัยที่เพิ่มขึ้นมากกว่าเกณฑ์การประเมินโครงการวิจัยแบบเร่งรัด ต้องนำเข้าพิจารณาแบบเต็มชุด </p>
                            <p style={{marginLeft:'5vw'}}>{JSON.parse(item.passedMeasure).includes("1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้") 
                            && <span style={{color:'green'}}>( <CheckOutlined /> )&nbsp;</span >||<span style={{color:'red'}}>( <CloseOutlined /> )&nbsp;</span>} 4. โครงการวิจัยที่ได้รับการรับรองแล้วและผู้วิจัยต้องการรายงานความก้าวหน้าของโครงการ (Progress Report) แต่มีการดำเนินการที่เบี่ยงเบนไม่ปฏิบัติตามหรือฝ่าฝืนโครงการวิจัยต้องนำเข้า พิจารณาแบบเต็มชุด</p>
                        </>}
                        <Table columns={[
                            {
                                title:'ประเด็นพิจารณา',
                                dataIndex:'Topic',
                                width:'15vw'
                            },{
                                title:'ข้อเสนอแนะ',
                                dataIndex:'Reccommendation',
                                render:(_,record,index)=>(
                                    <p
                                        style={{ fontSize: '16px', marginLeft: 20 }}
                                        dangerouslySetInnerHTML={{ 
                                            __html: (record?.Reccommendation || 'ไม่ได้ระบุ').replace(/\n/g, '<br/>') 
                                        }}
                                        />
                                )
                            }
                        ]} 
                        pagination={false} 
                        dataSource={JSON.parse(item.consideration_issues) as Issue[]}/>
                        <br/>
                        <Card>
                            <p>ข้อเสนอแนะเพิ่มเติม : {item.suggestion}</p>
                        </Card>
                    </Card></>}
                    </Card>
                    <br/>
                    
                    </>))}
                    <h2>สรุปข้อโต้แย้งของนักวิจัย</h2>
                    <Table
                        columns={[
                        {
                            title:'ประเด็นพิจารณา',
                            dataIndex:'Topic',
                            width:'15vw'
                        },{
                            title:'ข้อเสนอแนะ',
                            dataIndex:'Reccommendation',
                            render: (text: string) => (
                            <p
                                style={{ fontSize: '16px', marginLeft: 20 }}
                                dangerouslySetInnerHTML={{
                                __html: (text || '').replace(/\r\n|\n|\r/g, '<br/>'),
                                }}
                            />
                            ),
                            width:'15vw'
                        },{
                            title:'ข้อโต้แย้ง',
                            dataIndex:'Arguement',
                            width:'15vw'
                        }
                    ]} dataSource={consideratIssuesAndArguement}/>
                    <br/>
                    <Card>
                        <p>บันทึกข้อความของนักวิจัย : {AllData?.researcher_arguement||'-'}</p>
                    </Card>
                    <br/>
                    <Form form={Editform}>
                        <Form.Item name='status' label='กรุณาเลือกการกิจกกรรมของคุณต่อไปนี้'>
                            <Radio.Group
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 8,
                            }}
                            options={[
                                { value: 'ส่งไปยังกรรมการ', label: 'ส่งไปยังกรรมการ' },
                                { value: 'ตีกลับไปยังเจ้าหน้าที่', label: 'ตีกลับไปยังเจ้าหน้าที่' },
                            ]} />
                        </Form.Item>
                       {Stats=='ส่งไปยังกรรมการ'&& <Form.Item name='ReviewDeadline' label='วันสิ้นสุดการอนุมัติ'>
                        <DatePicker
                            disabledDate={(current) => {
                                return current && current < dayjs().startOf('day');
                            }}/>
                        </Form.Item>}
                        <Flex justify='center'><Button onClick={()=>setConfirmationMod(true)} >ยื่นโครงการให้กรรมการ</Button></Flex>
                    </Form>
                </Card>
             </>
          }

   


          <Modal
            footer={<></>}
            onCancel={()=>setConfirmationMod(false)}
            open={ConfirmationMod}>
            <h2>ยืนยันการส่งคำขอ</h2>
            <hr/>
                <p>คุณต้องการที่จะส่งข้อมูลไปถึงกรรมการที่ได้รับเชิญหรือไม่</p>
            <br/>
            <Flex justify='end'><Button onClick={()=>setConfirmationMod(false)} danger>ยกเลิก</Button>&nbsp;<Button color="primary" 
            onClick={()=>
                {
                    if(AllData?.project_status=='รอตรวจสอบจากประธานจริยธรรม'||
                        AllData?.project_status=='ประธานฯแต่งตั้งกรรมการใหม่'
                    )
                        {SetData()}
                    else if(AllData?.project_status=='รอตรวจสอบผลการแก้ไขจากประธาน')
                        {
                            SentEditedData()
                            }}} >ยืนยัน</Button></Flex>
          </Modal>
        </LoadingOverlay>
    </>)
}